<!-- Cargando: esqueleto con la FORMA de lo que viene, no una rueda girando en
     el medio de una pantalla vacía. Es el mismo recurso del listado. -->
<div *ngIf="planLoading" class="kb-page">
  <div class="kb-skeleton h-4 w-40"></div>
  <div class="kb-skeleton h-8 w-80"></div>
  <div class="grid grid-cols-1 xl:grid-cols-12 gap-6">
    <div class="xl:col-span-3 space-y-2">
      <div class="kb-skeleton h-9 w-full" *ngFor="let i of [1,2,3,4,5]"></div>
    </div>
    <div class="xl:col-span-9 space-y-4">
      <div class="kb-skeleton h-32 w-full"></div>
      <div class="kb-skeleton h-64 w-full"></div>
    </div>
  </div>
</div>

<!-- ══ El plan ════════════════════════════════════════════════════════════════
     🔴 Se fue la BANDA BLANCA a ancho completo que envolvía el encabezado
     (`bg-white shadow-sm border-b` + un contenedor `w-full`). Es uno de los
     gestos que hacen que una pantalla se lea vieja, y además rompía la
     alineación: el título arrancaba en el borde de la ventana y el contenido
     de abajo en otro lado. Ahora el encabezado vive sobre el mismo fondo y
     dentro del mismo ancho que el resto, con `kb-page`, igual que el listado.
     ══════════════════════════════════════════════════════════════════════ -->
<div *ngIf="!planLoading && plan" class="kb-page">

  <div>
        <!-- Breadcrumb -->
        <nav class="flex items-center space-x-2 text-sm text-muted-foreground mb-4">
          <button (click)="goBack()" class="hover:text-primary transition-colors flex items-center">
            <i class="fas fa-arrow-left mr-2"></i>
            Dashboard de Planes
          </button>
          <i class="fas fa-chevron-right text-xs"></i>
          <span class="text-foreground font-medium">{{ plan.code }}</span>
        </nav>

        <!-- Header Info -->
        <div class="kb-page-header">
          <div class="flex-1">
            <div class="flex items-center gap-3 mb-2">
              <h1 class="kb-page-title">{{ plan.name }}</h1>
              <span class="kb-badge"
                    [ngClass]="getStatusBadgeClass(plan.status)"
                    [title]="plan.status ? 'Plan activo y disponible para clientes' : 'Plan inactivo, no visible para clientes'">
                <i class="fas fa-circle text-xs mr-1"></i>
                {{ plan.status ? 'Activo' : 'Inactivo' }}
              </span>
            </div>
            <p class="kb-page-desc" [innerHTML]="plan.description"></p>

            <!-- Quick Info -->
            <div class="flex items-center space-x-6 mt-4 text-sm text-muted-foreground">
              <div class="flex items-center" title="Código único del plan">
                <i class="fas fa-code mr-2"></i>
                <span>{{ plan.code }}</span>
              </div>
              <!-- OCULTAR VISIBILIDAD POR SOLICITUD DEL USUARIO
              <div class="flex items-center" title="Visibilidad del plan">
                <i class="fas fa-eye mr-2"></i>
                <span>{{ getVisibilityText(plan.visibility) }}</span>
              </div>
              -->
              <div class="flex items-center" title="Fecha de creación">
                <i class="fas fa-calendar mr-2"></i>
                <span>Creado: {{ formatDate(plan.date) }}</span>
              </div>
              <div class="flex items-center" title="Versión actual">
                <i class="fas fa-code-branch mr-2"></i>
                <span>{{ plan.version?.internal_code || 'v1.0' }}</span>
              </div>
              <div class="flex items-center" title="Número de créditos asociados">
                <i class="fas fa-file-invoice mr-2"></i>
                <span>{{ plan.invoices || 0 }} créditos</span>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="flex items-center space-x-3">
            <button (click)="editPlan()"
                    title="Editar configuración del plan"
                    class="kb-btn kb-btn-outline">
              <i class="fas fa-edit mr-2"></i>
              Editar
            </button>
            <!--
            <button (click)="duplicatePlan()"
                    title="Crear una copia de este plan"
                    class="kb-btn kb-btn-outline">
              <i class="fas fa-copy mr-2"></i>
              Duplicar
            </button>
            -->
            <button (click)="togglePlanStatus()"
                    [title]="plan.status ? 'Desactivar plan (no será visible para clientes)' : 'Activar plan (será visible para clientes)'"
                    class="kb-btn"
                    [ngClass]="plan.status ? 'kb-btn-outline' : 'kb-btn-primary'">
              <i class="fas mr-2"
                 [class.fa-play]="!plan.status"
                 [class.fa-pause]="plan.status"></i>
              {{ plan.status ? 'Desactivar' : 'Activar' }}
            </button>
          </div>
        </div>
  </div>

  <!-- Main Layout: 3 Columns (Sidebar + Content + Help) -->
    <div class="grid grid-cols-1 xl:grid-cols-12 gap-6">

      <!-- Left Sidebar: Navigation -->
      <div class="xl:col-span-3">
        <div class="kb-card sticky top-8">
          <div class="p-4 border-b">
            <h3 class="text-sm font-semibold text-foreground uppercase tracking-wide">Navegación</h3>
            <p class="text-xs text-muted-foreground mt-1">Explora las diferentes secciones del plan</p>
          </div>
          <nav class="p-2">
            <button *ngFor="let section of getVisibleSections()"
                    (click)="navigateToSection(section.id)"
                    [title]="section.description"
                    class="w-full flex items-center gap-3 px-3 py-2 text-sm font-medium rounded-md transition-colors mb-0.5 group"
                    [ngClass]="activeSection === section.id
                               ? 'bg-primary/10 text-primary'
                               : 'text-muted-foreground hover:bg-accent/60 hover:text-foreground'">
              <span class="mr-3 text-sm">{{ section.icon }}</span>
              <span class="flex-1 text-left">{{ section.name }}</span>
              <i class="fas fa-chevron-right text-xs opacity-0 group-hover:opacity-100 transition-opacity"
                 [class.opacity-100]="activeSection === section.id"></i>
            </button>
          </nav>
        </div>
      </div>

      <!-- Main Content Area -->
      <div class="xl:col-span-9 space-y-6">

        <!-- Overview Metrics - Cintillo horizontal simple -->
        <!-- <div class="bg-card rounded-lg shadow-sm border p-4 mb-8">
          <div class="flex items-center justify-between">
            <h3 class="text-sm font-medium text-muted-foreground">Resumen General</h3>
            <div class="flex items-center space-x-8">
              <div class="flex items-center">
                <div class="w-6 h-6 bg-primary/10 rounded-full flex items-center justify-center mr-2">
                  <i class="fas fa-credit-card text-primary text-xs"></i>
                </div>
                <span class="text-sm text-muted-foreground mr-2">Créditos Activos:</span>
                <span class="text-sm font-bold text-foreground">{{ metrics.creditosActivos }}</span>
              </div>

              <div class="flex items-center">
                <div class="w-6 h-6 kb-caja-exito rounded-full flex items-center justify-center mr-2">
                  <i class="fas fa-check-circle kb-texto-exito text-xs"></i>
                </div>
                <span class="text-sm text-muted-foreground mr-2">Créditos Completados:</span>
                <span class="text-sm font-bold text-foreground">{{ metrics.creditosCompletados }}</span>
              </div>

              <div class="flex items-center">
                <div class="w-6 h-6 bg-primary/10 rounded-full flex items-center justify-center mr-2">
                  <i class="fas fa-users text-primary text-xs"></i>
                </div>
                <span class="text-sm text-muted-foreground mr-2">Clientes Activos:</span>
                <span class="text-sm font-bold text-foreground">{{ metrics.clientesActivos }}</span>
              </div>
            </div>
          </div>
        </div> -->

        <!-- Resumen Section -->
        <div id="section-resumen" class="kb-card p-6" *ngIf="activeSection === 'resumen'">
          <div class="mb-6">
            <h2 class="text-xl font-semibold text-foreground mb-2">📋 Resumen del Plan</h2>
            <p class="text-sm text-muted-foreground">Información completa del plan</p>
          </div>

          <!-- Etiquetas -->
          <div class="rounded-lg border border-border p-4 mb-6">
            <h3 class="font-semibold text-foreground mb-3">Etiquetas</h3>
            <div class="space-y-2">
              <div class="kb-fila">
                <span class="kb-fila-label">Modo de Filtro:</span>
                <span class="kb-fila-valor">
                  {{ plan.params?.filters?.dinamic_code?.person?.type === 'white_list' ? 'Lista Blanca' :
                     plan.params?.filters?.dinamic_code?.person?.type === 'black_list' ? 'Lista Negra' :
                     'Sin filtro configurado' }}
                </span>
              </div>
              <div class="kb-fila">
                <span class="kb-fila-label">Etiquetas Configuradas:</span>
                <span class="kb-fila-valor">{{ plan.params?.filters?.dinamic_code?.person?.list?.length || 0 }}</span>
              </div>
              <div class="flex justify-between" *ngIf="plan.params?.filters?.dinamic_code?.person?.list?.length > 0">
                <span class="text-muted-foreground">Etiquetas:</span>
                <span class="text-foreground">
                  <span *ngFor="let tag of plan.params.filters.dinamic_code.person.list.slice(0, 3); let last = last">
                    {{ tag }}<span *ngIf="!last">, </span>
                  </span>
                  <span *ngIf="plan.params.filters.dinamic_code.person.list.length > 3">
                    (+{{ plan.params.filters.dinamic_code.person.list.length - 3 }} más)
                  </span>
                </span>
              </div>
            </div>
          </div>

          <!-- Penalidades -->
          <div class="rounded-lg border border-border p-4 mb-6">
            <h3 class="font-semibold text-foreground mb-3">Penalidades (Fees)</h3>
            <div class="space-y-3">
              <!-- Lista Blanca -->
              <div>
                <div class="flex items-center mb-2">
                  <i class="fas fa-check-circle kb-texto-exito mr-2"></i>
                  <span class="text-sm font-medium text-foreground">Lista Blanca:</span>
                  <span class="ml-2 text-sm text-muted-foreground">
                    {{ getWhiteListFees().length || 0 }} 
                    {{ getWhiteListFees().length === 1 ? 'penalidad' : 'penalidades' }}
                  </span>
                </div>
                <div *ngIf="getWhiteListFees().length > 0; else noWhiteListFees" class="ml-6 space-y-1">
                  <div *ngFor="let feeCode of getWhiteListFees().slice(0, 3)" class="text-sm">
                    <span class="font-medium kb-texto-exito">{{ feeCode }}</span>
                    <span class="text-muted-foreground"> - {{ getFeeName(feeCode) }}</span>
                  </div>
                  <div *ngIf="getWhiteListFees().length > 3" class="text-xs kb-texto-exito italic">
                    +{{ getWhiteListFees().length - 3 }} más
                  </div>
                </div>
                <ng-template #noWhiteListFees>
                  <div class="ml-6 text-xs text-muted-foreground italic">
                    No hay penalidades en lista blanca
                  </div>
                </ng-template>
              </div>

              <!-- Lista Negra -->
              <div>
                <div class="flex items-center mb-2">
                  <i class="fas fa-ban text-destructive mr-2"></i>
                  <span class="text-sm font-medium text-foreground">Lista Negra:</span>
                  <span class="ml-2 text-sm text-muted-foreground">
                    {{ getBlackListFees().length || 0 }} 
                    {{ getBlackListFees().length === 1 ? 'penalidad' : 'penalidades' }}
                  </span>
                </div>
                <div *ngIf="getBlackListFees().length > 0; else noBlackListFees" class="ml-6 space-y-1">
                  <div *ngFor="let feeCode of getBlackListFees().slice(0, 3)" class="text-sm">
                    <span class="font-medium text-destructive">{{ feeCode }}</span>
                    <span class="text-muted-foreground"> - {{ getFeeName(feeCode) }}</span>
                  </div>
                  <div *ngIf="getBlackListFees().length > 3" class="text-xs text-destructive italic">
                    +{{ getBlackListFees().length - 3 }} más
                  </div>
                </div>
                <ng-template #noBlackListFees>
                  <div class="ml-6 text-xs text-muted-foreground italic">
                    No hay penalidades en lista negra
                  </div>
                </ng-template>
              </div>
            </div>
          </div>

          <!-- Productos -->
          <div class="rounded-lg border border-border p-4 mb-6">
            <h3 class="font-semibold text-foreground mb-3">Productos</h3>
            <div class="space-y-2">
              <div class="kb-fila">
                <span class="kb-fila-label">Identificador:</span>
                <span class="kb-fila-valor">{{ plan.params?.product_type || 'N/A' }}</span>
              </div>
              <div class="kb-fila">
                <span class="kb-fila-label">Producto:</span>
                <span class="kb-fila-valor">{{ parentProductName || 'Cargando...' }}</span>
              </div>
            </div>
          </div>

          <!-- Datos Básicos -->
          <div class="rounded-lg border border-border p-4 mb-6">
            <h3 class="font-semibold text-foreground mb-3">Datos Básicos</h3>
            <div class="space-y-2">
              <div class="kb-fila">
                <span class="kb-fila-label">Tipo:</span>
                <span class="kb-fila-valor">{{ getPlanTypeText() }}</span>
              </div>
              <div class="kb-fila">
                <span class="kb-fila-label">Estado del Plan:</span>
                <span class="kb-fila-valor">{{ (plan.status === true || plan.status === 'ACTIVE') ? 'Activo' : 'Inactivo' }}</span>
              </div>
              <div class="kb-fila">
                <span class="kb-fila-label">Nombre:</span>
                <span class="kb-fila-valor">{{ plan.name }}</span>
              </div>
              <div class="kb-fila">
                <span class="kb-fila-label">Código:</span>
                <span class="kb-fila-valor">{{ plan.code }}</span>
              </div>
              <div class="kb-fila">
                <span class="kb-fila-label">Multicompra:</span>
                <span class="kb-fila-valor">{{ plan.params?.multiple_invoices?.status ? 'Sí' : 'No' }}
                  <span *ngIf="plan.params?.multiple_invoices?.status && plan.params?.multiple_invoices?.count > 0" class="text-muted-foreground">
                    ({{ plan.params?.multiple_invoices?.count }})
                  </span>
                </span>
              </div>
              <!-- OCULTAR VISIBILIDAD POR SOLICITUD DEL USUARIO
              <div class="kb-fila">
                <span class="kb-fila-label">Visibilidad:</span>
                <span class="kb-fila-valor">{{ getVisibilityText(plan.visibility) }}</span>
              </div>
              -->
              <div class="kb-fila">
                <span class="kb-fila-label">Versión:</span>
                <span class="kb-fila-valor">{{ plan.version?.internal_code || 'v1.0' }}</span>
              </div>
              <div class="kb-fila">
                <span class="kb-fila-label">Prioridad:</span>
                <span class="kb-fila-valor">{{ plan.params?.priority || 0 }}</span>
              </div>
              <div class="kb-fila">
                <span class="kb-fila-label">Creado:</span>
                <span class="kb-fila-valor">{{ formatDate(plan.date) }}</span>
              </div>
              <div class="flex justify-between" *ngIf="plan.params?.init_date || plan.params?.end_date">
                <span class="text-muted-foreground">Vigencia:</span>
                <span class="text-foreground">
                  <span *ngIf="plan.params?.init_date">{{ formatDate(plan.params.init_date) }}</span>
                  <span *ngIf="plan.params?.init_date && plan.params?.end_date"> - </span>
                  <span *ngIf="plan.params?.end_date">{{ formatDate(plan.params.end_date) }}</span>
                  <span *ngIf="!plan.params?.end_date && plan.params?.init_date"> - Sin límite</span>
                </span>
              </div>
              <div class="flex justify-between" *ngIf="plan.description">
                <span class="text-muted-foreground">Descripción:</span>
                <span class="text-foreground" [innerHTML]="plan.description"></span>
              </div>
              <div class="flex justify-between" *ngIf="plan.params?.icon">
                <span class="text-muted-foreground">Icono:</span>
                <span class="text-foreground font-mono">{{ plan.params.icon }}</span>
              </div>
            </div>
          </div>

          <!-- Datos Generales (solo para crédito) -->
          <div class="rounded-lg border border-border p-4 mb-6" *ngIf="isPlanCredit()">
            <h3 class="font-semibold text-foreground mb-3">Datos Generales</h3>
            <div class="space-y-2">
              <div class="kb-fila">
                <span class="kb-fila-label">Requiere Inicial:</span>
                <span class="kb-fila-valor">{{ plan.initial?.status ? 'Sí' : 'No' }}</span>
              </div>
              <div class="flex justify-between" *ngIf="plan.initial?.status">
                <span class="text-muted-foreground">Forma de Cálculo:</span>
                <span class="text-foreground">{{ plan.initial?.type === 'percentage' ? 'Porcentaje' : 'Monto Absoluto' }}</span>
              </div>
              <div class="flex justify-between" *ngIf="plan.initial?.status">
                <span class="text-muted-foreground">Valor Inicial:</span>
                <span class="text-foreground">{{ plan.initial?.amount }}{{ plan.initial?.type === 'percentage' ? '%' : ' USD' }}</span>
              </div>
              <div class="flex justify-between" *ngIf="plan.params?.min_amount">
                <span class="text-muted-foreground">Monto Mínimo de Compra:</span>
                <span class="text-foreground">${{ plan.params?.min_amount }}</span>
              </div>
              <div class="kb-fila">
                <span class="kb-fila-label">Recalcular Cuotas:</span>
                <span class="kb-fila-valor">{{ plan.initial?.recalculate ? 'Sí' : 'No' }}</span>
              </div>
              <div class="flex justify-between" *ngIf="plan.payment_terms?.length > 0">
                <span class="text-muted-foreground">Opciones de Cuotas:</span>
                <span class="text-foreground">
                  <span *ngFor="let term of plan.payment_terms; let last = last">
                    {{ term.installments }}<span *ngIf="!last">, </span>
                  </span>
                </span>
              </div>
              <div class="flex justify-between" *ngIf="plan.payment_terms?.[0]?.frequency?.type">
                <span class="text-muted-foreground">Frecuencia:</span>
                <span class="text-foreground">
                  {{ plan.payment_terms?.[0]?.frequency?.type === 'mes' ? 'Mensual' :
                     plan.payment_terms?.[0]?.frequency?.type === 'quincenal' ? 'Quincenal' :
                     plan.payment_terms?.[0]?.frequency?.type === 'semanal' ? 'Semanal' :
                     plan.payment_terms?.[0]?.frequency?.type === 'semana' ? 'Semanal' :
                     'Días continuos' }}
                </span>
              </div>
              <div class="flex justify-between" *ngIf="plan.params?.current_quota_min">
                <span class="text-muted-foreground">Cupo Mínimo:</span>
                <span class="text-foreground">${{ plan.params?.current_quota_min }}</span>
              </div>
              <div class="flex justify-between" *ngIf="plan.params?.current_quota_max">
                <span class="text-muted-foreground">Cupo Máximo:</span>
                <span class="text-foreground">${{ plan.params?.current_quota_max }}</span>
              </div>
              <div class="flex justify-between" *ngIf="plan.params?.min_amount_base">
                <span class="text-muted-foreground">Monto Mínimo a Financiar:</span>
                <span class="text-foreground">${{ plan.params?.min_amount_base }}</span>
              </div>
              <div class="flex justify-between" *ngIf="plan.params?.max_amount_base">
                <span class="text-muted-foreground">Monto Máximo a Financiar:</span>
                <span class="text-foreground">${{ plan.params?.max_amount_base }}</span>
              </div>
            </div>
          </div>

          <!-- Filtros -->
          <div class="rounded-lg border border-border p-4 mb-6">
            <h3 class="font-semibold text-foreground mb-3">Filtros</h3>
            <div class="space-y-2">
              <div class="kb-fila">
                <span class="kb-fila-label">Filtro por Tipo de Persona:</span>
                <span class="kb-fila-valor">
                  {{ plan.params?.filters?.general?.person?.audience === 'NATURAL' ? 'Persona Natural' :
                     plan.params?.filters?.general?.person?.audience === 'JURIDICA' ? 'Persona Jurídica' :
                     'Sin filtro' }}
                </span>
              </div>
              <!-- ── multicomercio: a qué comercios aplica ─────────────────────
                   Se dice con palabras, no con un número: «Todos los comercios»
                   es una respuesta, «0» es un vacío que se lee como un error. -->
              <div class="kb-fila">
                <span class="kb-fila-label">Comercios a los que aplica:</span>
                <span class="kb-fila-valor">
                  {{ plan.params?.filters?.general?.invoices?.merchant?.list?.length > 0
                     ? plan.params.filters.general.invoices.merchant.list.length + ' comercio(s)'
                     : 'Todos los comercios' }}
                </span>
              </div>
              <div class="kb-fila" *ngIf="plan.params?.filters?.general?.invoices?.merchant?.list?.length > 0">
                <span class="kb-fila-label">Cuáles:</span>
                <span class="kb-fila-valor">
                  <span *ngFor="let c of plan.params.filters.general.invoices.merchant.list; let last = last">
                    {{ nombreComercio(c) }}<span *ngIf="!last">, </span>
                  </span>
                </span>
              </div>

              <div class="kb-fila">
                <span class="kb-fila-label">Filtro por Tiendas:</span>
                <span class="kb-fila-valor">
                  {{ plan.params?.filters?.general?.invoices?.shop?.type === 'white_list' ? 'Lista Blanca' :
                     plan.params?.filters?.general?.invoices?.shop?.type === 'black_list' ? 'Lista Negra' :
                     'Sin filtro' }}
                </span>
              </div>
              <div class="flex justify-between" *ngIf="plan.params?.filters?.general?.invoices?.shop?.list?.length > 0">
                <span class="text-muted-foreground">Tiendas Configuradas:</span>
                <span class="text-foreground">{{ plan.params?.filters?.general?.invoices?.shop?.list?.length }}</span>
              </div>
              <div class="kb-fila">
                <span class="kb-fila-label">Filtro por Productos:</span>
                <span class="kb-fila-valor">
                  {{ plan.params?.filters?.product_filter?.type === 'white_list' ? 'Lista Blanca' :
                     plan.params?.filters?.product_filter?.type === 'black_list' ? 'Lista Negra' :
                     'Sin filtro' }}
                </span>
              </div>
              <div class="flex justify-between" *ngIf="plan.params?.filters?.product_filter?.list?.length > 0">
                <span class="text-muted-foreground">Productos Configurados:</span>
                <span class="text-foreground">{{ plan.params?.filters?.product_filter?.list?.length }}</span>
              </div>
              <div *ngIf="plan.params?.filters?.product_filter?.list?.length > 0">
                <span class="text-muted-foreground">Códigos:</span>
                <div class="flex flex-wrap gap-1 mt-1">
                  <span *ngFor="let code of plan.params.filters.product_filter.list"
                        class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium kb-caja-alerta kb-texto-alerta border">
                    <i class="fas fa-box text-xs mr-1"></i>{{ code }}
                  </span>
                </div>
              </div>
              <div class="flex justify-between" *ngIf="plan.params?.filters?.product_filter?.type">
                <span class="text-muted-foreground">Modo de Coincidencia:</span>
                <span class="text-foreground">
                  {{ (plan.params?.filters?.product_filter?.match_mode === 'all' || plan.params?.filters?.product_filter?.strict_match === true)
                     ? 'Todos deben coincidir'
                     : 'Al menos uno' }}
                </span>
              </div>
              <div class="flex justify-between" *ngIf="plan.params?.filters?.product_filter?.type === 'white_list'">
                <span class="text-muted-foreground">Permite otros productos:</span>
                <span class="text-foreground">
                  {{ plan.params?.filters?.product_filter?.allow_others !== false ? 'Sí' : 'No' }}
                </span>
              </div>
            </div>
          </div>

          <!-- Otros -->
          <div class="border rounded-lg p-4">
            <h3 class="font-semibold text-foreground mb-3">Otros</h3>
            <div class="space-y-2">
              <div class="flex justify-between" *ngIf="plan.params?.generate_pagares !== undefined">
                <span class="text-muted-foreground">Pagaré electrónico:</span>
                <span class="text-foreground">{{ plan.params?.generate_pagares ? 'Sí' : 'No' }}</span>
              </div>
              <div class="flex justify-between" *ngIf="plan.params?.generate_pagares_fisico !== undefined">
                <span class="text-muted-foreground">Pagaré físico:</span>
                <span class="text-foreground">{{ plan.params?.generate_pagares_fisico ? 'Sí' : 'No' }}</span>
              </div>
              <div class="flex justify-between" *ngIf="plan.params?.allow_holidays !== undefined">
                <span class="text-muted-foreground">Diferimiento de cuotas:</span>
                <span class="text-foreground">{{ plan.params?.allow_holidays ? 'Diferir al día hábil' : 'Permitir en fines de semana' }}</span>
              </div>
              <div class="flex justify-between" *ngIf="plan.params?.auto_approve !== undefined">
                <span class="text-muted-foreground">Auto-aprobación:</span>
                <span class="text-foreground">{{ plan.params?.auto_approve ? 'Activada' : 'Desactivada' }}</span>
              </div>
              <div class="flex justify-between" *ngIf="plan.params?.send_notifications !== undefined">
                <span class="text-muted-foreground">Notificaciones:</span>
                <span class="text-foreground">{{ plan.params?.send_notifications ? 'Activadas' : 'Desactivadas' }}</span>
              </div>
            </div>
          </div>

        </div>

        <!-- Etiquetas Section -->
        <div id="section-etiquetas" class="kb-card p-6" *ngIf="activeSection === 'etiquetas'">
          <div class="flex items-center justify-between mb-6">
            <div>
              <h2 class="text-xl font-semibold text-foreground">Configuración de Etiquetas</h2>
              <p class="text-sm text-muted-foreground mt-1">Gestiona qué usuarios pueden acceder a este plan según sus etiquetas</p>
            </div>
            <!-- Botón de ayuda solo visible en pantallas menores a XL -->
            <div class="flex space-x-2">
              <button (click)="toggleHelp('etiquetas')"
                      class="text-sm text-muted-foreground hover:text-primary font-medium transition-colors"
                      [class.text-primary]="showHelp['etiquetas']">
                <i class="fas fa-question-circle mr-1"></i>
                {{ showHelp['etiquetas'] ? 'Ocultar' : 'Ayuda' }}
              </button>
            </div>
          </div>

          <!-- Ayuda Contextual - Solo visible en pantallas menores a XL -->
          <div *ngIf="showHelp['etiquetas']" class="kb-aviso kb-aviso-info mb-6">
            <div class="flex items-start">
              <i class="fas fa-info-circle text-primary mt-1 mr-3"></i>
              <div class="flex-1">
                <h4 class="kb-aviso-titulo mb-2">¿Cómo funcionan las Etiquetas?</h4>
                <div class="text-sm space-y-2">
                  <p><strong>Propósito:</strong> Las etiquetas permiten segmentar qué clientes pueden acceder a este plan.</p>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Modos de Filtro:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><strong>Lista Blanca:</strong> Solo usuarios CON estas etiquetas pueden acceder</li>
                      <li><strong>Lista Negra:</strong> Solo usuarios SIN estas etiquetas pueden acceder</li>
                    </ul>
                  </div>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Ejemplos de Etiquetas:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><code class="bg-card px-1 rounded">EMPLEADO_PUBLICO</code> - Funcionarios del sector público</li>
                      <li><code class="bg-card px-1 rounded">CLIENTE_PREMIUM</code> - Clientes con historial crediticio excelente</li>
                      <li><code class="bg-card px-1 rounded">MOROSO</code> - Clientes con pagos en mora</li>
                    </ul>
                  </div>

                  <div class="mt-3 p-2 rounded bg-primary/10">
                    <p class="font-medium text-xs">💡 Tip:</p>
                    <p class="text-xs">Sin etiquetas = Todos los usuarios pueden acceder</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Modo de Filtro -->
          <div class="mb-6">
            <h3 class="text-sm font-medium text-foreground mb-3">Modo de Filtro</h3>
            <div class="flex items-center space-x-4">
              <div class="flex items-center" *ngIf="plan.params?.filters?.dinamic_code?.person?.type === 'white_list'">
                <div class="kb-punto kb-punto-exito mr-2"></div>
                <span class="text-sm text-foreground">Lista Blanca</span>
                <span class="text-xs text-muted-foreground ml-2">(Solo usuarios CON estas etiquetas pueden acceder)</span>
              </div>
              <div class="flex items-center" *ngIf="plan.params?.filters?.dinamic_code?.person?.type === 'black_list'">
                <div class="w-3 h-3 bg-destructive rounded-full mr-2"></div>
                <span class="text-sm text-foreground">Lista Negra</span>
                <span class="text-xs text-muted-foreground ml-2">(Solo usuarios SIN estas etiquetas pueden acceder)</span>
              </div>
              <div class="flex items-center" *ngIf="!plan.params?.filters?.dinamic_code?.person?.type">
                <div class="kb-punto kb-punto-apagado mr-2"></div>
                <span class="text-sm text-muted-foreground">Sin filtro por etiquetas configurado</span>
              </div>
            </div>
          </div>

          <!-- Etiquetas Configuradas -->
          <div class="mb-6">
            <h3 class="text-sm font-medium text-foreground mb-3">Etiquetas Configuradas</h3>
            <div *ngIf="plan.params?.filters?.dinamic_code?.person?.list?.length > 0; else noEtiquetas">
              <div class="flex flex-wrap gap-2 mb-4">
                <span *ngFor="let code of plan.params.filters.dinamic_code.person.list"
                      class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-muted text-foreground border">
                  <i class="fas fa-tag text-xs mr-1"></i>
                  {{ code }}
                </span>
              </div>
              <p class="text-sm text-muted-foreground">
                <span class="font-medium">{{ plan.params.filters.dinamic_code.person.list.length }}</span>
                {{ plan.params.filters.dinamic_code.person.list.length === 1 ? 'etiqueta configurada' : 'etiquetas configuradas' }}
              </p>
            </div>
            <ng-template #noEtiquetas>
              <div class="text-center py-8 bg-muted/40 rounded-lg border-2 border-dashed border-border">
                <i class="fas fa-tags text-muted-foreground text-2xl mb-2"></i>
                <p class="text-sm text-muted-foreground">No hay etiquetas configuradas para este plan</p>
                <p class="text-xs text-muted-foreground mt-1">Todos los usuarios pueden acceder independientemente de sus etiquetas</p>
              </div>
            </ng-template>
          </div>

          <!-- Impacto de Audiencia -->
          <div class="mb-6" *ngIf="plan.params?.filters?.dinamic_code?.person?.list?.length > 0">
            <h3 class="text-sm font-medium text-foreground mb-3">Impacto de Audiencia</h3>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div class="bg-primary/5 p-4 rounded-lg border border-primary/30">
                <div class="flex items-center">
                  <i class="fas fa-users text-primary mr-2"></i>
                  <div>
                    <p class="text-sm font-medium text-foreground">Usuarios Elegibles</p>
                    <p class="text-lg font-semibold text-primary">{{ getEligibleUsersCount() }}</p>
                  </div>
                </div>
              </div>
              <div class="kb-caja-exito p-4 rounded-lg border">
                <div class="flex items-center">
                  <i class="fas fa-percentage kb-texto-exito mr-2"></i>
                  <div>
                    <p class="text-sm font-medium kb-texto-exito">% de Base Total</p>
                    <p class="text-lg font-semibold kb-texto-exito">{{ getEligibleUsersPercentage() }}%</p>
                  </div>
                </div>
              </div>
              <div class="bg-muted/50 p-4 rounded-lg border border-border">
                <div class="flex items-center">
                  <i class="fas fa-chart-pie text-primary mr-2"></i>
                  <div>
                    <p class="text-sm font-medium text-foreground">Alcance</p>
                    <p class="text-lg font-semibold text-foreground">{{ getReachLevel() }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Acciones -->
          <div class="mt-6 pt-6 border-t border-border">
            <div class="flex items-center justify-between">
              <div class="flex space-x-3">
                <button class="kb-btn kb-btn-outline"
                        *ngIf="plan.params?.filters?.dinamic_code?.person?.list?.length > 0">
                  <i class="fas fa-users mr-2"></i>
                  Ver Usuarios Afectados
                </button>
              </div>
              <button class="kb-btn kb-btn-outline"
                      *ngIf="plan.params?.filters?.dinamic_code?.person?.list?.length > 0">
                <i class="fas fa-download mr-2"></i>
                Exportar Lista
              </button>
            </div>
          </div>
        </div>

        <!-- NUEVA SECCIÓN: FILTROS -->
        <div id="section-filtros" class="kb-card p-6" *ngIf="activeSection === 'filtros'">
          <div class="flex items-center justify-between mb-6">
            <div>
              <h2 class="text-xl font-semibold text-foreground">🔍 Filtros</h2>
              <p class="text-sm text-muted-foreground mt-1">Configuración avanzada de elegibilidad del plan</p>
            </div>
            <!-- Botón de ayuda solo visible en pantallas menores a XL -->
            <div class="flex space-x-2">
              <button (click)="toggleHelp('filtros')"
                      class="text-sm text-muted-foreground hover:text-primary font-medium transition-colors"
                      [class.text-primary]="showHelp['filtros']">
                <i class="fas fa-question-circle mr-1"></i>
                {{ showHelp['filtros'] ? 'Ocultar' : 'Ayuda' }}
              </button>
            </div>
          </div>

          <!-- Ayuda Contextual - Solo visible en pantallas menores a XL -->
          <div *ngIf="showHelp['filtros']" class="kb-aviso kb-aviso-info mb-6">
            <div class="flex items-start">
              <i class="fas fa-info-circle text-primary mt-1 mr-3"></i>
              <div class="flex-1">
                <h4 class="kb-aviso-titulo mb-2">¿Cómo funcionan los Filtros?</h4>
                <div class="text-sm space-y-2">
                  <p><strong>Propósito:</strong> Los filtros controlan qué usuarios y en qué tiendas está disponible este plan.</p>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Tipos de Filtros:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><strong>Persona:</strong> Filtra por tipo de cliente (Natural/Jurídica)</li>
                      <li><strong>Tiendas:</strong> Controla en qué puntos de venta está disponible</li>
                      <li><strong>Códigos Dinámicos:</strong> Filtros avanzados por etiquetas específicas</li>
                    </ul>
                  </div>

                  <div class="mt-3 p-2 rounded bg-primary/10">
                    <p class="font-medium text-xs">💡 Tip:</p>
                    <p class="text-xs">Combina múltiples filtros para un control granular de elegibilidad</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Filtro por Tipo de Persona -->
          <div class="mb-8">
            <h3 class="text-lg font-medium text-foreground mb-4 flex items-center">
              <i class="fas fa-user-tag text-primary mr-2"></i>
              Filtro por Tipo de Persona
            </h3>

            <div *ngIf="plan.params?.filters?.general?.person?.audience; else noPersonFilter">
              <div class="kb-caja-exito border rounded-lg p-4">
                <div class="flex items-center justify-between">
                  <div class="flex items-center space-x-3">
                    <div class="w-10 h-10 kb-caja-exito rounded-lg flex items-center justify-center">
                      <i class="fas fa-user-check kb-texto-exito"></i>
                    </div>
                    <div>
                      <h4 class="text-lg font-semibold text-foreground">
                        {{ plan.params.filters.general.person.audience === 'NATURAL' ? 'Persona Natural' : 'Persona Jurídica' }}
                      </h4>
                      <p class="text-sm text-muted-foreground">
                        Solo disponible para {{ plan.params.filters.general.person.audience === 'NATURAL' ? 'personas naturales' : 'empresas y organizaciones' }}
                      </p>
                    </div>
                  </div>
                  <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium kb-caja-exito kb-texto-exito">
                    <i class="fas fa-check-circle mr-1"></i>
                    Activo
                  </span>
                </div>
              </div>
            </div>

            <ng-template #noPersonFilter>
              <div class="text-center py-8 bg-muted/40 rounded-lg border-2 border-dashed border-border">
                <i class="fas fa-users text-muted-foreground text-2xl mb-2"></i>
                <p class="text-sm text-muted-foreground">Sin filtro por tipo de persona</p>
                <p class="text-xs text-muted-foreground mt-1">Disponible para personas naturales y jurídicas</p>
              </div>
            </ng-template>
          </div>

          <!-- Filtro por Tiendas -->
          <div class="mb-8">
            <h3 class="text-lg font-medium text-foreground mb-4 flex items-center">
              <i class="fas fa-store text-primary mr-2"></i>
              Filtro por Tiendas
            </h3>

            <div *ngIf="plan.params?.filters?.general?.invoices?.shop; else noShopFilter">
              <!-- Modo de Filtro de Tiendas -->
              <div class="mb-4">
                <div class="flex items-center space-x-4 mb-3">
                  <div class="flex items-center" *ngIf="plan.params.filters.general.invoices.shop.type === 'white_list'">
                    <div class="kb-punto kb-punto-exito mr-2"></div>
                    <span class="text-sm text-foreground font-medium">Lista Blanca</span>
                    <span class="text-xs text-muted-foreground ml-2">(Solo disponible EN estas tiendas)</span>
                  </div>
                  <div class="flex items-center" *ngIf="plan.params.filters.general.invoices.shop.type === 'black_list'">
                    <div class="w-3 h-3 bg-destructive rounded-full mr-2"></div>
                    <span class="text-sm text-foreground font-medium">Lista Negra</span>
                    <span class="text-xs text-muted-foreground ml-2">(Disponible EXCEPTO en estas tiendas)</span>
                  </div>
                </div>
              </div>

              <!-- Tiendas Configuradas -->
              <div *ngIf="plan.params.filters.general.invoices.shop.list?.length > 0">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 mb-4">
                  <div *ngFor="let shop of plan.params.filters.general.invoices.shop.list"
                       class="bg-card border border-border rounded-lg p-3 flex items-center space-x-3">
                    <div class="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                      <i class="fas fa-store text-primary text-sm"></i>
                    </div>
                    <div class="flex-1 min-w-0">
                      <p class="text-sm font-medium text-foreground truncate">{{ shop }}</p>
                      <p class="text-xs text-muted-foreground">ID: {{ shop }}</p>
                    </div>
                  </div>
                </div>

                <div class="bg-muted/50 border border-border rounded-lg p-3">
                  <p class="text-sm text-foreground">
                    <span class="font-medium">{{ plan.params.filters.general.invoices.shop.list.length }}</span>
                    {{ plan.params.filters.general.invoices.shop.list.length === 1 ? 'tienda configurada' : 'tiendas configuradas' }}
                  </p>
                </div>
              </div>
            </div>

            <ng-template #noShopFilter>
              <div class="text-center py-8 bg-muted/40 rounded-lg border-2 border-dashed border-border">
                <i class="fas fa-store-slash text-muted-foreground text-2xl mb-2"></i>
                <p class="text-sm text-muted-foreground">Sin filtro por tiendas</p>
                <p class="text-xs text-muted-foreground mt-1">Disponible en todas las tiendas del sistema</p>
              </div>
            </ng-template>
          </div>

          <!-- Códigos Dinámicos Adicionales (Other) -->
          <div class="mb-8" *ngIf="plan.params?.filters?.dinamic_code?.other">
            <h3 class="text-lg font-medium text-foreground mb-4 flex items-center">
              <i class="fas fa-code kb-texto-alerta mr-2"></i>
              Códigos Dinámicos Adicionales
            </h3>

            <!-- Modo de Filtro -->
            <div class="mb-4">
              <div class="flex items-center space-x-4 mb-3">
                <div class="flex items-center" *ngIf="plan.params.filters.dinamic_code.other.type === 'white_list'">
                  <div class="kb-punto kb-punto-exito mr-2"></div>
                  <span class="text-sm text-foreground font-medium">Lista Blanca</span>
                  <span class="text-xs text-muted-foreground ml-2">(Solo usuarios CON estos códigos)</span>
                </div>
                <div class="flex items-center" *ngIf="plan.params.filters.dinamic_code.other.type === 'black_list'">
                  <div class="w-3 h-3 bg-destructive rounded-full mr-2"></div>
                  <span class="text-sm text-foreground font-medium">Lista Negra</span>
                  <span class="text-xs text-muted-foreground ml-2">(Solo usuarios SIN estos códigos)</span>
                </div>
              </div>
            </div>

            <!-- Códigos Configurados -->
            <div *ngIf="plan.params.filters.dinamic_code.other.list?.length > 0; else noOtherCodes">
              <div class="flex flex-wrap gap-2 mb-4">
                <span *ngFor="let code of plan.params.filters.dinamic_code.other.list"
                      class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium kb-caja-alerta kb-texto-alerta border">
                  <i class="fas fa-code text-xs mr-1"></i>
                  {{ code }}
                </span>
              </div>

              <div class="kb-caja-alerta border rounded-lg p-3">
                <p class="text-sm kb-texto-alerta">
                  <span class="font-medium">{{ plan.params.filters.dinamic_code.other.list.length }}</span>
                  {{ plan.params.filters.dinamic_code.other.list.length === 1 ? 'código adicional configurado' : 'códigos adicionales configurados' }}
                </p>
              </div>
            </div>

            <ng-template #noOtherCodes>
              <div class="text-center py-6 bg-muted/40 rounded-lg border-2 border-dashed border-border">
                <i class="fas fa-code text-muted-foreground text-xl mb-2"></i>
                <p class="text-sm text-muted-foreground">Sin códigos adicionales configurados</p>
              </div>
            </ng-template>
          </div>

          <!-- Resumen de Impacto de Filtros -->
          <div class="mt-8 pt-6 border-t border-border" *ngIf="hasAnyFilters()">
            <h3 class="text-lg font-medium text-foreground mb-4 flex items-center">
              <i class="fas fa-chart-bar text-primary mr-2"></i>
              Impacto de Filtros Combinados
            </h3>

            <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div class="bg-muted/50 p-4 rounded-lg border border-border">
                <div class="flex items-center">
                  <i class="fas fa-filter text-primary mr-2"></i>
                  <div>
                    <p class="text-sm font-medium text-foreground">Filtros Activos</p>
                    <p class="text-lg font-semibold text-foreground">{{ getActiveFiltersCount() }}</p>
                  </div>
                </div>
              </div>
              <div class="bg-primary/5 p-4 rounded-lg border border-primary/30">
                <div class="flex items-center">
                  <i class="fas fa-users text-primary mr-2"></i>
                  <div>
                    <p class="text-sm font-medium text-foreground">Usuarios Elegibles</p>
                    <p class="text-lg font-semibold text-primary">{{ getFilteredEligibleUsersCount() }}</p>
                  </div>
                </div>
              </div>
              <div class="kb-caja-exito p-4 rounded-lg border">
                <div class="flex items-center">
                  <i class="fas fa-store kb-texto-exito mr-2"></i>
                  <div>
                    <p class="text-sm font-medium kb-texto-exito">Tiendas Disponibles</p>
                    <p class="text-lg font-semibold kb-texto-exito">{{ getAvailableStoresCount() }}</p>
                  </div>
                </div>
              </div>
              <div class="bg-muted/50 p-4 rounded-lg border border-border">
                <div class="flex items-center">
                  <i class="fas fa-percentage text-primary mr-2"></i>
                  <div>
                    <p class="text-sm font-medium text-foreground">Alcance Total</p>
                    <p class="text-lg font-semibold text-foreground">{{ getFilteredReachLevel() }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Acciones -->
          <div class="mt-6 pt-6 border-t border-border" *ngIf="hasAnyFilters()">
            <div class="flex items-center justify-between">
              <div class="flex space-x-3">
                <button class="kb-btn kb-btn-outline">
                  <i class="fas fa-users mr-2"></i>
                  Simular Audiencia
                </button>
                <button class="kb-btn kb-btn-outline">
                  <i class="fas fa-store mr-2"></i>
                  Ver Tiendas Afectadas
                </button>
              </div>
              <button class="kb-btn kb-btn-outline">
                <i class="fas fa-download mr-2"></i>
                Exportar Configuración
              </button>
            </div>
          </div>
        </div>

        <!-- Penalidades Section -->
        <div id="section-penalidades" class="kb-card p-6" *ngIf="activeSection === 'penalidades'">
          <div class="flex items-center justify-between mb-6">
            <div>
              <h2 class="text-xl font-semibold text-foreground">Configuración de Penalidades (Fees)</h2>
              <p class="text-sm text-muted-foreground mt-1">Gestiona las penalidades que se aplicarán en este plan</p>
            </div>
            <!-- Botón de ayuda solo visible en pantallas menores a XL -->
            <div class="flex space-x-2">
              <button (click)="toggleHelp('penalidades')"
                      class="text-sm text-muted-foreground hover:text-primary font-medium transition-colors"
                      [class.text-primary]="showHelp['penalidades']">
                <i class="fas fa-question-circle mr-1"></i>
                {{ showHelp['penalidades'] ? 'Ocultar' : 'Ayuda' }}
              </button>
            </div>
          </div>

          <!-- Ayuda Contextual - Solo visible en pantallas menores a XL -->
          <div *ngIf="showHelp['penalidades']" class="kb-aviso kb-aviso-info mb-6">
            <div class="flex items-start">
              <i class="fas fa-info-circle text-primary mt-1 mr-3"></i>
              <div class="flex-1">
                <h4 class="kb-aviso-titulo mb-2">¿Cómo funcionan las Penalidades?</h4>
                <div class="text-sm space-y-3 text-primary">
                  <p><strong>Propósito:</strong> Las penalidades (fees) son cargos adicionales que se aplican al plan de crédito.</p>

                  <div class="mt-3">
                    <p class="font-medium mb-2">Tipos de Listas:</p>
                    <ul class="list-disc list-inside space-y-2 ml-2">
                      <li><strong>Lista Blanca:</strong> Solo estas penalidades específicas se pueden aplicar al plan</li>
                      <li><strong>Lista Negra:</strong> Estas penalidades NO se pueden aplicar al plan (están excluidas)</li>
                    </ul>
                  </div>

                  <div class="mt-3 p-3 rounded bg-primary/10 border border-primary/30">
                    <p class="font-medium text-sm mb-2">🔍 Reglas de Aplicación:</p>
                    <div class="space-y-2 text-xs">
                      <div class="p-2 bg-card rounded">
                        <p class="font-medium kb-texto-exito mb-1">✓ Si la penalidad está ACTIVA en el producto:</p>
                        <p>Aplica a <strong>todos los planes</strong> automáticamente, excepto si se agrega a la <strong>Lista Negra</strong> del plan.</p>
                      </div>
                      <div class="p-2 bg-card rounded">
                        <p class="font-medium kb-texto-alerta mb-1">⊗ Si la penalidad está INACTIVA en el producto:</p>
                        <p>Solo aplica si se agrega explícitamente a la <strong>Lista Blanca</strong> del plan.</p>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3 p-2 rounded bg-primary/10">
                    <p class="font-medium text-xs">💡 Tip:</p>
                    <p class="text-xs">Si un plan no tiene listas configuradas, se aplican todas las penalidades activas del sistema</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Lista Blanca -->
          <div class="mb-6">
            <h3 class="text-sm font-medium text-foreground mb-3 flex items-center">
              <i class="fas fa-check-circle kb-texto-exito mr-2"></i>
              Lista Blanca de Penalidades
            </h3>
            <div *ngIf="getWhiteListFees().length > 0; else noWhiteListFeesDetail">
              <div class="space-y-2 mb-4">
                <div *ngFor="let feeCode of getWhiteListFees()"
                      class="flex items-center justify-between p-3 kb-caja-exito border rounded-lg">
                  <div class="flex-1">
                    <div class="font-medium text-foreground">{{ feeCode }}</div>
                    <div class="text-sm text-muted-foreground">{{ getFeeName(feeCode) }}</div>
                  </div>
                  <i class="fas fa-check-circle kb-texto-exito"></i>
                </div>
              </div>
              <p class="text-sm text-muted-foreground">
                <span class="font-medium">{{ getWhiteListFees().length }}</span>
                {{ getWhiteListFees().length === 1 ? 'penalidad permitida' : 'penalidades permitidas' }}
              </p>
            </div>
            <ng-template #noWhiteListFeesDetail>
              <div class="text-center py-8 bg-muted/40 rounded-lg border-2 border-dashed border-border">
                <i class="fas fa-check-circle text-muted-foreground text-2xl mb-2"></i>
                <p class="text-sm text-muted-foreground">No hay penalidades en la Lista Blanca</p>
                <p class="text-xs text-muted-foreground mt-1">Se pueden aplicar todas las penalidades (excepto las de Lista Negra)</p>
              </div>
            </ng-template>
          </div>

          <!-- Lista Negra -->
          <div class="mb-6">
            <h3 class="text-sm font-medium text-foreground mb-3 flex items-center">
              <i class="fas fa-ban text-destructive mr-2"></i>
              Lista Negra de Penalidades
            </h3>
            <div *ngIf="getBlackListFees().length > 0; else noBlackListFeesDetail">
              <div class="space-y-2 mb-4">
                <div *ngFor="let feeCode of getBlackListFees()"
                      class="flex items-center justify-between p-3 bg-destructive/5 border border-destructive/30 rounded-lg">
                  <div class="flex-1">
                    <div class="font-medium text-foreground">{{ feeCode }}</div>
                    <div class="text-sm text-muted-foreground">{{ getFeeName(feeCode) }}</div>
                  </div>
                  <i class="fas fa-ban text-destructive"></i>
                </div>
              </div>
              <p class="text-sm text-muted-foreground">
                <span class="font-medium">{{ getBlackListFees().length }}</span>
                {{ getBlackListFees().length === 1 ? 'penalidad excluida' : 'penalidades excluidas' }}
              </p>
            </div>
            <ng-template #noBlackListFeesDetail>
              <div class="text-center py-8 bg-muted/40 rounded-lg border-2 border-dashed border-border">
                <i class="fas fa-ban text-muted-foreground text-2xl mb-2"></i>
                <p class="text-sm text-muted-foreground">No hay penalidades en la Lista Negra</p>
                <p class="text-xs text-muted-foreground mt-1">No hay penalidades excluidas para este plan</p>
              </div>
            </ng-template>
          </div>

          <!-- Resumen -->
          <div class="bg-primary/5 p-4 rounded-lg border border-primary/30">
            <div class="flex items-start">
              <i class="fas fa-info-circle text-primary mt-1 mr-3"></i>
              <div class="flex-1">
                <h4 class="kb-aviso-titulo mb-2">Resumen de Configuración</h4>
                <div class="text-sm text-primary space-y-1">
                  <p *ngIf="getWhiteListFees().length > 0">
                    <strong>✓</strong> Solo se pueden aplicar {{ getWhiteListFees().length }} 
                    {{ getWhiteListFees().length === 1 ? 'penalidad específica' : 'penalidades específicas' }}
                  </p>
                  <p *ngIf="getBlackListFees().length > 0">
                    <strong>✗</strong> Se excluyen {{ getBlackListFees().length }} 
                    {{ getBlackListFees().length === 1 ? 'penalidad' : 'penalidades' }}
                  </p>
                  <p *ngIf="getWhiteListFees().length === 0 && getBlackListFees().length === 0" class="text-muted-foreground">
                    Sin restricciones configuradas - Se pueden aplicar todas las penalidades del sistema
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- Productos Section -->
        <div id="section-productos" class="kb-card p-6" *ngIf="activeSection === 'productos'">
          <div class="flex items-center justify-between mb-6">
            <div>
              <h2 class="text-xl font-semibold text-foreground">🛍️ Productos</h2>
              <p class="text-sm text-muted-foreground mt-1">Identificadores asignados a este plan</p>
            </div>
            <!-- Botón de ayuda solo visible en pantallas menores a XL -->
            <div class="flex space-x-2">
              <button (click)="toggleHelp('productos')"
                      class="text-sm text-muted-foreground hover:text-primary font-medium transition-colors"
                      [class.text-primary]="showHelp['productos']">
                <i class="fas fa-question-circle mr-1"></i>
                {{ showHelp['productos'] ? 'Ocultar' : 'Ayuda' }}
              </button>
            </div>
          </div>

          <!-- Ayuda Contextual - Solo visible en pantallas menores a XL -->
          <div *ngIf="showHelp['productos']" class="kb-aviso kb-aviso-info mb-6">
            <div class="flex items-start">
              <i class="fas fa-info-circle kb-texto-exito mt-1 mr-3"></i>
              <div class="flex-1">
                <h4 class="text-sm font-semibold mb-2 kb-texto-exito">¿Cómo funcionan los Productos?</h4>
                <div class="text-sm space-y-2 kb-texto-exito">
                  <p><strong>Propósito:</strong> Los identificadores determinan a qué productos se aplica este plan.</p>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Tipos Disponibles:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><code class="bg-card px-1 rounded">CREDIT</code> - Productos de crédito básico</li>
                      <li><code class="bg-card px-1 rounded">RECHARGE</code> - Productos de recarga</li>
                      <li><code class="bg-card px-1 rounded">SEGUROS_MERCANTIL</code> - Seguros del Banco Mercantil</li>
                    </ul>
                  </div>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Funcionamiento:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><strong>Restricción:</strong> Solo se puede asignar UN identificador por plan</li>
                      <li><strong>Herencia:</strong> El plan hereda las características del producto</li>
                    </ul>
                  </div>

                  <div class="mt-3 p-2 rounded kb-caja-exito">
                    <p class="font-medium text-xs">💡 Tip:</p>
                    <p class="text-xs">Solo se puede asignar UN identificador por plan</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Identificador Principal -->
          <div *ngIf="plan.params?.product_type; else noProductSelected">
            <!-- Card Simple -->
            <div class="bg-primary/5 border border-primary/30 rounded-lg p-4 mb-4">
              <div class="flex items-center justify-between">
                <div class="flex items-center space-x-3">
                  <div class="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                    <i class="fas fa-tag text-primary"></i>
                  </div>
                  <div>
                    <h3 class="text-lg font-semibold text-foreground">{{ plan.params.product_type }}</h3>
                    <p class="text-sm text-muted-foreground">
                      <span *ngIf="parentProductName && parentProductName !== plan.params.product_type">
                        {{ parentProductName }}
                      </span>
                      <span *ngIf="!parentProductName" class="text-muted-foreground">
                        Producto no encontrado en el sistema
                      </span>
                      <span *ngIf="parentProductName === plan.params.product_type" class="text-muted-foreground">
                        Identificador de producto
                      </span>
                    </p>
                  </div>
                </div>
                <div class="text-right">
                  <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium kb-caja-exito kb-texto-exito">
                    <i class="fas fa-check-circle mr-1"></i>
                    Activo
                  </span>
                </div>
              </div>
              
              <!-- Información de Seguros (si aplica) -->
              <div *ngIf="plan.params?.insurance && (plan.params.insurance.plan || plan.params.insurance.brokerage)" 
                   class="mt-4 pt-4 border-t border-primary/30">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <!-- Propuesta de Seguro -->
                  <div *ngIf="plan.params.insurance.plan" class="bg-card rounded-lg p-3">
                    <div class="flex items-start">
                      <div class="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                        <i class="fas fa-file-contract text-primary text-sm"></i>
                      </div>
                      <div class="flex-1 min-w-0">
                        <p class="text-xs font-medium text-muted-foreground mb-1">Propuesta de Seguro</p>
                        <p class="text-sm font-semibold text-foreground" [title]="getInsuranceProposalName(plan.params.insurance.plan)">
                          {{ getInsuranceProposalName(plan.params.insurance.plan) }}
                        </p>
                        <p class="text-xs text-muted-foreground mt-1 font-mono">ID: {{ plan.params.insurance.plan }}</p>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Aseguradora -->
                  <div *ngIf="plan.params.insurance.brokerage" class="bg-card rounded-lg p-3">
                    <div class="flex items-start">
                      <div class="w-8 h-8 kb-caja-exito rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                        <i class="fas fa-shield-alt kb-texto-exito text-sm"></i>
                      </div>
                      <div class="flex-1 min-w-0">
                        <p class="text-xs font-medium text-muted-foreground mb-1">Aseguradora</p>
                        <p class="text-sm font-semibold text-foreground truncate" [title]="getInsurerName(plan.params.insurance.brokerage)">
                          {{ getInsurerName(plan.params.insurance.brokerage) }}
                        </p>
                        <p class="text-xs text-muted-foreground mt-1">Código: {{ plan.params.insurance.brokerage }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ng-template #noProductSelected>
            <div class="text-center py-8 kb-caja-alerta rounded-lg border">
              <i class="fas fa-exclamation-triangle kb-texto-alerta text-2xl mb-2"></i>
              <p class="text-sm kb-texto-alerta">Sin identificador configurado</p>
              <button class="kb-btn kb-btn-outline kb-btn-sm mt-2">
                Configurar
              </button>
            </div>
          </ng-template>

          <!-- Acciones Simples -->
          <div class="flex space-x-3 pt-4 border-t border-border">
            <button class="px-4 py-2 border border-border rounded-md text-sm text-foreground hover:bg-accent/60">
              <i class="fas fa-edit mr-2"></i>
              Cambiar ID
            </button>
            <button class="px-4 py-2 border border-border rounded-md text-sm text-foreground hover:bg-accent/60">
              <i class="fas fa-list mr-2"></i>
              Ver Todos
            </button>
            <button class="px-4 py-2 border border-border rounded-md text-sm text-foreground hover:bg-accent/60">
              <i class="fas fa-download mr-2"></i>
              Exportar
            </button>
          </div>
        </div>

        <!-- Datos Básicos Section -->
        <div id="section-datos-basicos" class="kb-card p-6" *ngIf="activeSection === 'datos-basicos'">
          <div class="flex items-center justify-between mb-6">
            <div>
              <h2 class="text-xl font-semibold text-foreground">Datos Básicos</h2>
              <p class="text-sm text-muted-foreground mt-1">Información fundamental del plan</p>
            </div>
            <!-- Botón de ayuda solo visible en pantallas menores a XL -->
            <div class="flex space-x-2">
              <button (click)="toggleHelp('datos-basicos')"
                      class="text-sm text-muted-foreground hover:text-primary font-medium transition-colors"
                      [class.text-primary]="showHelp['datos-basicos']">
                <i class="fas fa-question-circle mr-1"></i>
                {{ showHelp['datos-basicos'] ? 'Ocultar' : 'Ayuda' }}
              </button>
            </div>
          </div>

          <!-- Ayuda Contextual - Solo visible en pantallas menores a XL -->
          <div *ngIf="showHelp['datos-basicos']" class="kb-aviso kb-aviso-info mb-6">
            <div class="flex items-start">
              <i class="fas fa-info-circle text-primary mt-1 mr-3"></i>
              <div class="flex-1">
                <h4 class="kb-aviso-titulo mb-2">¿Qué son los Datos Básicos?</h4>
                <div class="text-sm space-y-2">
                  <p><strong>Propósito:</strong> Define la identidad y configuración fundamental del plan.</p>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Campos Principales:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><strong>Nombre:</strong> Identificación amigable del plan (ej: "Plan Empleados 2024")</li>
                      <li><strong>Código:</strong> Identificador único inmutable (ej: "EMP_2024_V1")</li>
                      <li><strong>Descripción:</strong> Detalles del plan para clientes</li>
                    </ul>
                  </div>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Estados del Plan:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><span class="kb-texto-exito">●</span> <strong>Activo:</strong> Visible y disponible para clientes</li>
                      <li><span class="text-destructive">●</span> <strong>Inactivo:</strong> Oculto para clientes</li>
                    </ul>
                  </div>

                  <div class="mt-3 p-2 rounded kb-caja-alerta">
                    <p class="font-medium text-xs">⚠️ Importante:</p>
                    <p class="text-xs">El código NO se puede cambiar una vez creado</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Información Simple -->
          <div class="space-y-3">

            <div class="grid grid-cols-2 gap-4">
              <div>
                <span class="text-sm text-muted-foreground">Tipo:</span>
                <div class="ml-2 flex items-center">
                  <span class="kb-badge"
                        [ngClass]="isPlanCredit() ? 'kb-badge-marca' : 'kb-badge-exito'">
                    <i class="mr-1"
                       [class.fas]="true"
                       [class.fa-credit-card]="isPlanCredit()"
                       [class.fa-money-bill-wave]="!isPlanCredit()"></i>
                    {{ getPlanTypeText() }}
                  </span>
                </div>
              </div>
              <div>
                <span class="text-sm text-muted-foreground">Estado del Plan:</span>
                <span class="text-sm ml-2 font-medium"
                      [class.kb-texto-exito]="plan.status === true || plan.status === 'ACTIVE'"
                      [class.text-destructive]="plan.status === false || plan.status === 'INACTIVE'">
                  {{ (plan.status === true || plan.status === 'ACTIVE') ? 'Activo' : 'Inactivo' }}
                </span>
              </div>
            </div>

            <div class="grid grid-cols-2 gap-4">
              <div>
                <span class="text-sm text-muted-foreground">Nombre:</span>
                <span class="text-sm text-foreground ml-2">{{ plan.name }}</span>
              </div>
              <div>
                <span class="text-sm text-muted-foreground">Código:</span>
                <span class="text-sm text-foreground ml-2 font-mono">{{ plan.code }}</span>
              </div>
            </div>

            <div class="grid grid-cols-2 gap-4">
              <div>
                <span class="text-sm text-muted-foreground">Multicompra:</span>
                <span class="text-sm text-foreground ml-2">
                  {{ plan.params?.multiple_invoices?.status ? 'Sí' : 'No' }}
                  <span *ngIf="plan.params?.multiple_invoices?.status && plan.params?.multiple_invoices?.count > 0" class="text-muted-foreground">
                    ({{ plan.params?.multiple_invoices?.count }})
                  </span>
                </span>
              </div>
              <!-- OCULTAR VISIBILIDAD POR SOLICITUD DEL USUARIO
              <div class="kb-fila">
                <span class="kb-fila-label">Visibilidad:</span>
                <span class="kb-fila-valor">{{ getVisibilityText(plan.visibility) }}</span>
              </div>
              -->
              <div class="kb-fila">
                <span class="kb-fila-label">Versión:</span>
                <span class="kb-fila-valor">{{ plan.version?.internal_code || 'v1.0' }}</span>
              </div>
            </div>

            <div class="grid grid-cols-2 gap-4">
              <div>
                <span class="text-sm text-muted-foreground">Prioridad:</span>
                <span class="text-sm text-foreground ml-2">{{ plan.params?.priority || 0 }}</span>
              </div>
            </div>

            <div class="grid grid-cols-2 gap-4">
              <div>
                <span class="text-sm text-muted-foreground">Creado:</span>
                <span class="text-sm text-foreground ml-2">{{ formatDate(plan.date) }}</span>
              </div>
              <div *ngIf="plan.params?.init_date || plan.params?.end_date">
                <span class="text-sm text-muted-foreground">Vigencia:</span>
                <span class="text-sm text-foreground ml-2">
                  <span *ngIf="plan.params?.init_date">{{ formatDate(plan.params.init_date) }}</span>
                  <span *ngIf="plan.params?.init_date && plan.params?.end_date"> - </span>
                  <span *ngIf="plan.params?.end_date">{{ formatDate(plan.params.end_date) }}</span>
                  <span *ngIf="!plan.params?.end_date && plan.params?.init_date"> - Sin límite</span>
                </span>
              </div>
            </div>

            <div *ngIf="plan.description" class="pt-3 border-t border-border">
              <span class="text-sm text-muted-foreground">Descripción:</span>
              <p class="text-sm text-foreground mt-1" [innerHTML]="plan.description"></p>
            </div>

            <!-- Icono del plan si existe -->
            <div *ngIf="plan.params?.icon" class="pt-3 border-t border-border">
              <span class="text-sm text-muted-foreground">Icono:</span>
              <div class="flex items-center mt-1">
                <i [class]="plan.params.icon + 'text-2xl text-primary mr-3'"></i>
                <span class="text-sm text-muted-foreground font-mono">{{ plan.params.icon }}</span>
              </div>
            </div>
          </div>

        </div>

        <!-- Datos Generales Section -->
        <div id="section-datos-generales" class="kb-card p-6" *ngIf="activeSection === 'datos-generales' && isSectionVisible('datos-generales')">
          <div class="flex items-center justify-between mb-6">
            <div>
              <h2 class="text-xl font-semibold text-foreground">Datos Generales</h2>
              <p class="text-sm text-muted-foreground mt-1">Configuración financiera y términos de crédito</p>
            </div>
            <!-- Botón de ayuda solo visible en pantallas menores a XL -->
            <div class="flex space-x-2">
              <button (click)="toggleHelp('datos-generales')"
                      class="text-sm text-muted-foreground hover:text-primary font-medium transition-colors"
                      [class.text-primary]="showHelp['datos-generales']">
                <i class="fas fa-question-circle mr-1"></i>
                {{ showHelp['datos-generales'] ? 'Ocultar' : 'Ayuda' }}
              </button>
            </div>
          </div>

          <!-- Ayuda Contextual - Solo visible en pantallas menores a XL -->
          <div *ngIf="showHelp['datos-generales']" class="kb-aviso kb-aviso-info mb-6">
            <div class="flex items-start">
              <i class="fas fa-info-circle kb-texto-alerta mt-1 mr-3"></i>
              <div class="flex-1">
                <h4 class="text-sm font-semibold mb-2 kb-texto-alerta">¿Cómo configurar los Datos Generales?</h4>
                <div class="text-sm space-y-2 kb-texto-alerta">
                  <p><strong>Propósito:</strong> Configuración financiera y términos de crédito del plan.</p>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Pago Inicial:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><strong>Requiere inicial:</strong> Si el plan exige pago inicial</li>
                      <li><strong>Tipo de cálculo:</strong> Porcentaje o monto fijo (ej: 20% o $50)</li>
                      <li><strong>Recalcular cuotas:</strong> Si ajusta cuotas tras el inicial</li>
                    </ul>
                  </div>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Plazos y Cuotas:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><strong>Opciones de cuotas:</strong> Cantidad de cuotas disponibles (ej: 2, 3, 4 cuotas)</li>
                      <li><strong>Frecuencia:</strong> Periodicidad de pago (ej: Mensual, quincenal)</li>
                    </ul>
                  </div>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Límites de Cupo:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><strong>Cupo mínimo/máximo:</strong> Rango de cupo asignable</li>
                      <li><strong>Monto mín/máx a financiar:</strong> Límites por transacción</li>
                    </ul>
                  </div>

                  <div class="mt-3 p-2 bg-card rounded border">
                    <p class="font-medium text-xs mb-1">Ejemplo Plan Empleados:</p>
                    <ul class="text-xs space-y-1">
                      <li>• Inicial: 20% del monto</li>
                      <li>• Cuotas: 2, 3, 4 opciones</li>
                      <li>• Cupo: $500 - $2,000</li>
                    </ul>
                  </div>

                  <div class="mt-3 p-2 rounded kb-caja-alerta">
                    <p class="font-medium text-xs">💡 Tip:</p>
                    <p class="text-xs">Define términos de crédito y límites según el perfil de usuario</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Pago Inicial -->
          <div class="mb-8">
            <h3 class="text-lg font-medium text-foreground mb-4">Pago Inicial</h3>
            <div class="grid grid-cols-2 gap-4">
              <div>
                <span class="text-sm text-muted-foreground">Requiere Inicial:</span>
                <span class="text-sm ml-2 font-medium"
                      [class.kb-texto-exito]="plan.initial?.status"
                      [class.text-destructive]="!plan.initial?.status">
                  {{ plan.initial?.status ? 'Sí' : 'No' }}
                </span>
              </div>
              <div>
                <span class="text-sm text-muted-foreground">Forma de Cálculo:</span>
                <span class="text-sm text-foreground ml-2">
                  {{ plan.initial?.type === 'percentage' ? 'Porcentaje' : 'Monto Absoluto' }}
                </span>
              </div>
              <div>
                <span class="text-sm text-muted-foreground">Valor Inicial:</span>
                <span class="text-sm text-foreground ml-2 font-medium">
                  {{ plan.initial?.amount }}{{ plan.initial?.type === 'percentage' ? '%' : ' USD' }}
                </span>
              </div>
              <div>
                <span class="text-sm text-muted-foreground">Monto Mínimo de Compra:</span>
                <span class="text-sm text-foreground ml-2">${{ plan.params?.min_amount || 'No definido' }}</span>
              </div>
              <div>
                <span class="text-sm text-muted-foreground">Recalcular Cuotas:</span>
                <span class="text-sm ml-2 font-medium"
                      [class.kb-texto-exito]="plan.initial?.recalculate"
                      [class.text-destructive]="!plan.initial?.recalculate">
                  {{ plan.initial?.recalculate ? 'Sí' : 'No' }}
                </span>
              </div>
            </div>
          </div>

          <!-- Plazos -->
          <div class="mb-8">
            <h3 class="text-lg font-medium text-foreground mb-4">Plazos</h3>
            <div class="grid grid-cols-2 gap-4">
              <div>
                <span class="text-sm text-muted-foreground">Opciones de Cuotas:</span>
                <span class="text-sm text-foreground ml-2">
                  <span *ngFor="let term of plan.payment_terms; let last = last" class="font-medium">
                    {{ term.installments }}<span *ngIf="!last">, </span>
                  </span>
                </span>
              </div>
              <div>
                <span class="text-sm text-muted-foreground">Frecuencia:</span>
                <span class="text-sm text-foreground ml-2">
                  {{ plan.payment_terms?.[0]?.frequency?.type === 'mes' ? 'Mensual' :
                     plan.payment_terms?.[0]?.frequency?.type === 'quincenal' ? 'Quincenal' :
                     plan.payment_terms?.[0]?.frequency?.type === 'semanal' ? 'Semanal' :
                     plan.payment_terms?.[0]?.frequency?.type === 'semana' ? 'Semanal' :
                     'Días continuos' }}
                </span>
              </div>
            </div>
          </div>

          <!-- Cupo -->
          <div>
            <h3 class="text-lg font-medium text-foreground mb-4">Cupo</h3>
            <div class="grid grid-cols-2 gap-4">
              <div>
                <span class="text-sm text-muted-foreground">Cupo Mínimo:</span>
                <span class="text-sm text-foreground ml-2">${{ plan.params?.current_quota_min || 'No definido' }}</span>
              </div>
              <div>
                <span class="text-sm text-muted-foreground">Cupo Máximo:</span>
                <span class="text-sm text-foreground ml-2">${{ plan.params?.current_quota_max || 'No definido' }}</span>
              </div>
              <div>
                <span class="text-sm text-muted-foreground">Monto Mínimo a Financiar:</span>
                <span class="text-sm text-foreground ml-2">${{ plan.params?.min_amount_base || 'No definido' }}</span>
              </div>
              <div>
                <span class="text-sm text-muted-foreground">Monto Máximo a Financiar:</span>
                <span class="text-sm text-foreground ml-2">${{ plan.params?.max_amount_base || 'No definido' }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Active Clients Section -->
        <div id="section-clientes" class="kb-card p-6" *ngIf="activeSection === 'clientes'">
          <div class="flex items-center justify-between mb-6">
            <div>
              <h2 class="text-xl font-semibold text-foreground">Clientes Activos</h2>
              <p class="text-sm text-muted-foreground mt-1">Usuarios que actualmente tienen créditos con este plan</p>
            </div>
            <div class="flex space-x-2">
              <!-- Botón de ayuda solo visible en pantallas menores a XL -->
              <button (click)="toggleHelp('clientes')"
                      class="text-sm text-muted-foreground hover:text-primary font-medium transition-colors"
                      [class.text-primary]="showHelp['clientes']">
                <i class="fas fa-question-circle mr-1"></i>
                {{ showHelp['clientes'] ? 'Ocultar' : 'Ayuda' }}
              </button>
              <button class="text-sm text-primary hover:text-primary/80 font-medium">
                <i class="fas fa-download mr-1"></i>
                Exportar
              </button>
              <button class="text-sm text-primary hover:text-primary/80 font-medium">
                <i class="fas fa-filter mr-1"></i>
                Filtrar
              </button>
            </div>
          </div>

          <!-- Ayuda Contextual - Solo visible en pantallas menores a XL -->
          <div *ngIf="showHelp['clientes']" class="kb-aviso kb-aviso-info mb-6">
            <div class="flex items-start">
              <i class="fas fa-info-circle text-primary mt-1 mr-3"></i>
              <div class="flex-1">
                <h4 class="kb-aviso-titulo mb-2">¿Cómo interpretar los Clientes?</h4>
                <div class="text-sm space-y-2">
                  <p><strong>Propósito:</strong> Usuarios que actualmente tienen créditos activos con este plan.</p>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Estados de Cliente:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><span class="kb-texto-exito">●</span> <strong>Al día:</strong> Pagos al corriente</li>
                      <li><span class="text-destructive">●</span> <strong>Atrasado:</strong> Pagos en mora</li>
                    </ul>
                  </div>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Información Mostrada:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><strong>Crédito activo:</strong> Monto actual del crédito</li>
                      <li><strong>Progreso:</strong> Cuotas pagadas vs total</li>
                      <li><strong>Fecha inicio:</strong> Cuándo se otorgó el crédito</li>
                    </ul>
                  </div>

                  <div class="mt-3 p-2 rounded bg-primary/10">
                    <p class="font-medium text-xs">📊 Análisis:</p>
                    <p class="text-xs">Evalúa el rendimiento y riesgo del plan</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="clientsLoading" class="text-center py-12">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
            <p class="text-muted-foreground mt-2">Cargando clientes...</p>
          </div>

          <div *ngIf="!clientsLoading && activeClients.length > 0" class="overflow-x-auto">
            <table class="kb-table">
              <thead class="kb-thead">
                <tr>
                  <th class="kb-th">Cliente</th>
                  <th class="kb-th">Crédito</th>
                  <th class="kb-th">Estado</th>
                  <th class="kb-th">Progreso</th>
                  <th class="kb-th">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let client of activeClients; trackBy: trackByClientId" class="kb-tr">
                  <td class="kb-td">
                    <div>
                      <p class="kb-td-titulo">{{ client.name }}</p>
                      <p class="kb-td-sub">{{ client.email }}</p>
                    </div>
                  </td>
                  <td class="kb-td">
                    {{ formatCurrency(client.creditoActivo) }}
                  </td>
                  <td class="kb-td">
                    <span class="kb-badge"
                          [ngClass]="getClientStatusBadgeClass(client.estado)">
                      {{ client.estado }}
                    </span>
                  </td>
                  <td class="kb-td">
                    <div class="flex items-center">
                      <div class="flex-1 bg-muted rounded-full h-2 mr-2">
                        <div class="bg-primary h-2 rounded-full"
                             [style.width.%]="(client.cuotasPagadas / client.cuotasTotal) * 100"></div>
                      </div>
                      <span class="text-sm text-muted-foreground">{{ client.cuotasPagadas }}/{{ client.cuotasTotal }}</span>
                    </div>
                  </td>
                  <td class="kb-td kb-td-acciones">
                    <button class="text-primary hover:text-primary/80 mr-3" title="Ver detalles del cliente">
                      <i class="fas fa-eye"></i>
                    </button>
                    <button class="text-muted-foreground hover:text-foreground" title="Contactar cliente">
                      <i class="fas fa-envelope"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="!clientsLoading && activeClients.length === 0" class="text-center py-12">
            <i class="fas fa-users text-muted-foreground text-4xl mb-4"></i>
            <p class="text-muted-foreground text-lg">No hay clientes activos</p>
            <p class="text-muted-foreground text-sm">Este plan aún no tiene clientes con créditos activos</p>
          </div>
        </div>

        <!-- Version History Section -->
        <div id="section-historial" class="kb-card p-6" *ngIf="activeSection === 'historial'">
          <div class="flex items-center justify-between mb-6">
            <div>
              <h2 class="text-xl font-semibold text-foreground">Historial de Versiones</h2>
              <p class="text-sm text-muted-foreground mt-1">Registro de cambios y modificaciones realizadas al plan</p>
            </div>
            <!-- Botón de ayuda solo visible en pantallas menores a XL -->
            <button (click)="toggleHelp('historial')"
                    class="text-sm text-muted-foreground hover:text-primary font-medium transition-colors"
                    [class.text-primary]="showHelp['historial']">
              <i class="fas fa-question-circle mr-1"></i>
              {{ showHelp['historial'] ? 'Ocultar' : 'Ayuda' }}
            </button>
          </div>

          <!-- Ayuda Contextual - Solo visible en pantallas menores a XL -->
          <div *ngIf="showHelp['historial']" class="kb-aviso kb-aviso-info mb-6">
            <div class="flex items-start">
              <i class="fas fa-info-circle text-muted-foreground mt-1 mr-3"></i>
              <div class="flex-1">
                <h4 class="kb-aviso-titulo mb-2">¿Para qué sirve el Historial?</h4>
                <div class="text-sm space-y-2">
                  <p><strong>Propósito:</strong> Registro completo de cambios y modificaciones del plan.</p>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Tipos de Cambios:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><strong>Modificaciones:</strong> Cambios en configuración</li>
                      <li><strong>Versiones:</strong> Nuevas versiones del plan</li>
                      <li><strong>Estados:</strong> Activación/desactivación</li>
                    </ul>
                  </div>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Información de Auditoría:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><strong>Fecha y hora:</strong> Cuándo se realizó el cambio</li>
                      <li><strong>Usuario:</strong> Quién realizó la modificación</li>
                      <li><strong>Detalles:</strong> Qué campos se modificaron</li>
                    </ul>
                  </div>

                  <div class="mt-3 p-2 rounded bg-muted">
                    <p class="font-medium text-xs">🔍 Auditoría:</p>
                    <p class="text-xs">Esencial para cumplimiento y trazabilidad</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="historyLoading" class="text-center py-12">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
            <p class="text-muted-foreground mt-2">Cargando historial...</p>
          </div>

          <div *ngIf="!historyLoading" class="space-y-6">
            <div *ngFor="let version of versionHistory; let i = index"
                 class="relative pl-6 pb-6"
                 [class.border-l-2]="i < versionHistory.length - 1"
                 [class.border-border]="i < versionHistory.length - 1">

              <!-- Timeline dot -->
              <div class="absolute left-0 top-0 -translate-x-1/2 w-3 h-3 bg-primary rounded-full border-2 border-card shadow"></div>

              <div class="bg-muted/40 rounded-lg p-4">
                <div class="flex items-center justify-between mb-3">
                  <h3 class="text-sm font-semibold text-foreground">{{ version.version.internal_code }}</h3>
                  <span class="text-xs text-muted-foreground bg-card px-2 py-1 rounded">{{ formatDate(version.version.date_init_version) }}</span>
                </div>

                <div class="space-y-2 mb-3">
                  <div *ngFor="let change of version.changes" class="text-sm">
                    <span class="font-medium text-foreground">{{ change.field }}:</span>
                    <span class="text-muted-foreground ml-1">{{ change.newValue }}</span>
                  </div>
                </div>

                <div class="flex items-center text-xs text-muted-foreground">
                  <i class="fas fa-user mr-1"></i>
                  <span>Modificado por: {{ version.user }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Metrics Section -->
        <div id="section-metricas" class="kb-card p-6" *ngIf="activeSection === 'metricas'">
          <div class="flex items-center justify-between mb-6">
            <div>
              <h2 class="text-xl font-semibold text-foreground">Métricas y Análisis</h2>
              <p class="text-sm text-muted-foreground mt-1">Indicadores de rendimiento y estadísticas del plan</p>
            </div>
            <div class="flex space-x-2">
              <!-- Botón de ayuda solo visible en pantallas menores a XL -->
              <button (click)="toggleHelp('metricas')"
                      class="text-sm text-muted-foreground hover:text-primary font-medium transition-colors"
                      [class.text-primary]="showHelp['metricas']">
                <i class="fas fa-question-circle mr-1"></i>
                {{ showHelp['metricas'] ? 'Ocultar' : 'Ayuda' }}
              </button>
              <select class="text-sm border-border rounded-md">
                <option>Último mes</option>
                <option>Últimos 3 meses</option>
                <option>Último año</option>
              </select>
            </div>
          </div>

          <!-- Ayuda Contextual - Solo visible en pantallas menores a XL -->
          <div *ngIf="showHelp['metricas']" class="kb-aviso kb-aviso-info mb-6">
            <div class="flex items-start">
              <i class="fas fa-info-circle text-primary mt-1 mr-3"></i>
              <div class="flex-1">
                <h4 class="kb-aviso-titulo mb-2">¿Cómo interpretar las Métricas?</h4>
                <div class="text-sm space-y-2">
                  <p><strong>Propósito:</strong> Indicadores de rendimiento y estadísticas del plan.</p>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Indicadores Clave:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><span class="kb-texto-exito">●</span> <strong>Tasa de aprobación:</strong> Porcentaje de solicitudes aprobadas</li>
                      <li><strong>Promedio por crédito:</strong> Monto promedio otorgado</li>
                      <li><strong>Ingresos del mes:</strong> Ingresos generados por el plan</li>
                    </ul>
                  </div>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Interpretación:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><span class="kb-texto-exito">●</span> <strong>Verde:</strong> Indicadores positivos</li>
                      <li><span class="text-destructive">●</span> <strong>Rojo:</strong> Requiere atención</li>
                      <li><strong>Tendencias:</strong> Observa cambios en el tiempo</li>
                    </ul>
                  </div>

                  <div class="mt-3 p-2 rounded bg-primary/10">
                    <p class="font-medium text-xs">📈 Optimización:</p>
                    <p class="text-xs">Usa estas métricas para mejorar el rendimiento del plan</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div class="kb-card p-6 hover:shadow-md transition-shadow">
              <div class="flex items-center">
                <i class="fas fa-percentage text-primary text-2xl mr-4 flex-shrink-0"></i>
                <div class="min-w-0 flex-1">
                  <p class="text-sm font-medium text-primary truncate">Tasa de Aprobación</p>
                  <p [ngClass]="getDynamicTextSizeClass(formatPercentage(metrics.tasaAprobacion))" class="text-foreground">{{ formatPercentage(metrics.tasaAprobacion) }}</p>
                  <p class="text-xs text-primary mt-1 truncate">De solicitudes recibidas</p>
                </div>
              </div>
            </div>

            <div class="kb-card p-6 hover:shadow-md transition-shadow">
              <div class="flex items-center">
                <i class="fas fa-chart-line kb-texto-exito text-2xl mr-4 flex-shrink-0"></i>
                <div class="min-w-0 flex-1">
                  <p class="text-sm font-medium kb-texto-exito truncate">Promedio por Crédito</p>
                  <p [ngClass]="getDynamicCurrencySize(metrics.promedioMonto)" class="kb-texto-exito">{{ formatCurrency(metrics.promedioMonto) }}</p>
                  <p class="text-xs kb-texto-exito mt-1 truncate">Monto promedio otorgado</p>
                </div>
              </div>
            </div>

            <div class="kb-card p-6 hover:shadow-md transition-shadow">
              <div class="flex items-center">
                <i class="fas fa-coins text-primary text-2xl mr-4 flex-shrink-0"></i>
                <div class="min-w-0 flex-1">
                  <p class="text-sm font-medium text-foreground truncate">Ingresos del Mes</p>
                  <p [ngClass]="getDynamicCurrencySize(metrics.ingresosMes)" class="text-foreground">{{ formatCurrency(metrics.ingresosMes) }}</p>
                  <p class="text-xs text-foreground mt-1 truncate">Ingresos generados</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Otros Section -->
        <div id="section-otros" class="kb-card p-6" *ngIf="activeSection === 'otros'">
          <div class="flex items-center justify-between mb-6">
            <div>
              <h2 class="text-xl font-semibold text-foreground">⚙️ Otros</h2>
              <p class="text-sm text-muted-foreground mt-1">Configuración adicional de documentación legal y políticas</p>
            </div>
            <!-- Botón de ayuda solo visible en pantallas menores a XL -->
            <div class="flex space-x-2">
              <button (click)="toggleHelp('otros')"
                      class="text-sm text-muted-foreground hover:text-primary font-medium transition-colors"
                      [class.text-primary]="showHelp['otros']">
                <i class="fas fa-question-circle mr-1"></i>
                {{ showHelp['otros'] ? 'Ocultar' : 'Ayuda' }}
              </button>
            </div>
          </div>

          <!-- Ayuda Contextual - Solo visible en pantallas menores a XL -->
          <div *ngIf="showHelp['otros']" class="kb-aviso kb-aviso-info mb-6">
            <div class="flex items-start">
              <i class="fas fa-info-circle kb-texto-alerta mt-1 mr-3"></i>
              <div class="flex-1">
                <h4 class="text-sm font-semibold mb-2 kb-texto-alerta">¿Qué configurar en Otros?</h4>
                <div class="text-sm space-y-2 kb-texto-alerta">
                  <p><strong>Propósito:</strong> Configuración adicional de documentación legal y políticas de cobranza.</p>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Documentación Legal:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><strong>Pagaré Electrónico:</strong> Genera automáticamente documento digital</li>
                      <li><strong>Pagaré Físico:</strong> Requiere documento físico firmado</li>
                    </ul>
                  </div>

                  <div class="mt-3">
                    <p class="font-medium mb-1">Políticas de Cobranza:</p>
                    <ul class="list-disc list-inside space-y-1 ml-2">
                      <li><strong>Permitir cuotas en feriados:</strong> Si las fechas de pago pueden caer en fines de semana o feriados</li>
                      <li><strong>Ajuste automático:</strong> Mueve fechas al siguiente día hábil si está desactivado</li>
                      <li><strong>Diferir cuotas en feriados:</strong> Mueve automáticamente las cuotas de fines de semana y feriados al siguiente día hábil</li>
                      <li><strong>Permitir en cualquier día:</strong> Las fechas pueden caer en cualquier día si está desactivado</li>
                    </ul>
                  </div>

                  <div class="mt-3 p-2 rounded kb-caja-alerta">
                    <p class="font-medium text-xs">⚖️ Legal:</p>
                    <p class="text-xs">Los pagarés son documentos legales que respaldan el crédito</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Documentación Legal -->
          <div class="mb-8">
            <h3 class="text-lg font-medium text-foreground mb-4 flex items-center">
              <i class="fas fa-file-contract text-primary mr-2"></i>
              Documentación Legal
            </h3>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <!-- Pagaré Electrónico -->
              <div class="bg-primary/5 border border-primary/30 rounded-lg p-4">
                <div class="flex items-center justify-between mb-3">
                  <div class="flex items-center">
                    <i class="fas fa-file-digital text-primary mr-2"></i>
                    <h4 class="text-md font-medium text-foreground">Pagaré Electrónico</h4>
                  </div>
                  <div class="flex items-center">
                    <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                          [class.kb-caja-exito]="plan.params?.generate_pagares"
                          [class.kb-texto-exito]="plan.params?.generate_pagares"
                          [class.bg-muted]="!plan.params?.generate_pagares"
                          [class.text-foreground]="!plan.params?.generate_pagares">
                      <i class="fas text-xs mr-1"
                         [class.fa-check-circle]="plan.params?.generate_pagares"
                         [class.fa-times-circle]="!plan.params?.generate_pagares"></i>
                      {{ plan.params?.generate_pagares ? 'Activado' : 'Desactivado' }}
                    </span>
                  </div>
                </div>
                <p class="text-sm text-muted-foreground mb-3">
                  {{ plan.params?.generate_pagares ?
                     'Se generará automáticamente un pagaré digital al formalizar el crédito.' :
                     'No se generará pagaré electrónico para este plan.' }}
                </p>
                <div class="flex items-center text-xs text-muted-foreground">
                  <i class="fas fa-info-circle mr-1"></i>
                  <span>{{ plan.params?.generate_pagares ? 'Proceso automático y ágil' : 'Sin documentación digital' }}</span>
                </div>
              </div>

              <!-- Pagaré Físico -->
              <div class="kb-caja-alerta border rounded-lg p-4">
                <div class="flex items-center justify-between mb-3">
                  <div class="flex items-center">
                    <i class="fas fa-file-signature kb-texto-alerta mr-2"></i>
                    <h4 class="text-md font-medium text-foreground">Pagaré Físico</h4>
                  </div>
                  <div class="flex items-center">
                    <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                          [class.kb-caja-exito]="plan.params?.generate_pagares_fisico"
                          [class.kb-texto-exito]="plan.params?.generate_pagares_fisico"
                          [class.bg-muted]="!plan.params?.generate_pagares_fisico"
                          [class.text-foreground]="!plan.params?.generate_pagares_fisico">
                      <i class="fas text-xs mr-1"
                         [class.fa-check-circle]="plan.params?.generate_pagares_fisico"
                         [class.fa-times-circle]="!plan.params?.generate_pagares_fisico"></i>
                      {{ plan.params?.generate_pagares_fisico ? 'Activado' : 'Desactivado' }}
                    </span>
                  </div>
                </div>
                <p class="text-sm text-muted-foreground mb-3">
                  {{ plan.params?.generate_pagares_fisico ?
                     'Se requerirá la firma de un pagaré físico como respaldo adicional del crédito.' :
                     'No se requiere pagaré físico para este plan.' }}
                </p>
                <div class="flex items-center text-xs text-muted-foreground">
                  <i class="fas fa-info-circle mr-1"></i>
                  <span>{{ plan.params?.generate_pagares_fisico ? 'Requiere proceso presencial' : 'Sin documentación física' }}</span>
                </div>
              </div>
            </div>

            <!-- Resumen de Documentación -->
            <div class="mt-4 p-3 bg-muted/40 rounded-lg border border-border">
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <i class="fas fa-clipboard-check text-muted-foreground mr-2"></i>
                  <span class="text-sm font-medium text-foreground">Estado de Documentación:</span>
                </div>
                <div class="flex items-center space-x-4">
                  <span class="text-sm text-muted-foreground">
                    <span *ngIf="plan.params?.generate_pagares || plan.params?.generate_pagares_fisico; else noDocuments">
                      {{ (plan.params?.generate_pagares ? 1 : 0) + (plan.params?.generate_pagares_fisico ? 1 : 0) }}
                      tipo{{ (plan.params?.generate_pagares && plan.params?.generate_pagares_fisico) ? 's' : '' }} configurado{{ (plan.params?.generate_pagares && plan.params?.generate_pagares_fisico) ? 's' : '' }}
                    </span>
                    <ng-template #noDocuments>
                      <span class="kb-texto-alerta">Sin documentación configurada</span>
                    </ng-template>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Políticas de Cobranza (Solo para planes A CRÉDITO) -->
          <div class="mb-8" *ngIf="isPlanCredit()">
            <h3 class="text-lg font-medium text-foreground mb-4 flex items-center">
              <i class="fas fa-calendar-alt kb-texto-exito mr-2"></i>
              Políticas de Cobranza
            </h3>

            <div class="kb-caja-exito border rounded-lg p-4">
              <div class="flex items-center justify-between mb-3">
                <div class="flex items-center">
                  <i class="fas fa-calendar-week kb-texto-exito mr-2"></i>
                  <h4 class="text-md font-medium text-foreground">Diferimiento de Cuotas en Fines de Semana y Feriados</h4>
                </div>
                <div class="flex items-center">
                  <span class="kb-badge"
                        [ngClass]="plan.params?.weekday ? 'kb-badge-exito' : 'kb-badge-alerta'">
                    <i class="fas text-xs mr-1"
                       [class.fa-check-circle]="plan.params?.weekday"
                       [class.fa-times-circle]="!plan.params?.weekday"></i>
                    {{ plan.params?.weekday ? 'Diferir al día hábil' : 'Permitir en fines de semana' }}
                  </span>
                </div>
              </div>

              <p class="text-sm text-muted-foreground mb-3">
                <span *ngIf="plan.params?.weekday; else noWeekendPayments">
                  Las fechas de vencimiento de cuotas que caigan en fines de semana o feriados se diferirán automáticamente al siguiente día hábil.
                </span>
                <ng-template #noWeekendPayments>
                  Las fechas de vencimiento de cuotas pueden caer en cualquier día, incluyendo fines de semana y feriados.
                </ng-template>
              </p>

              <div class="flex items-start space-x-2 text-xs text-muted-foreground">
                <i class="fas fa-lightbulb mt-0.5"></i>
                <div>
                  <p class="font-medium mb-1">Recomendación:</p>
                  <p *ngIf="!plan.params?.weekday">
                    <span class="kb-texto-exito">✓ Configuración recomendada</span> - Evita confusiones con fechas de pago en días no laborables.
                  </p>
                  <p *ngIf="plan.params?.weekday">
                    <span class="kb-texto-alerta">⚠ Considerar cambio</span> - Puede generar confusión en clientes sobre fechas de pago efectivas.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Mensaje para Planes DE CONTADO -->
          <div class="mb-8" *ngIf="!isPlanCredit()">
            <div class="bg-primary/5 border border-primary/30 rounded-lg p-4">
              <div class="flex items-center">
                <i class="fas fa-info-circle text-primary mr-3"></i>
                <div>
                  <h4 class="text-sm font-medium text-primary mb-1">Plan de Contado</h4>
                  <p class="text-sm text-primary">
                    Las políticas de cobranza no aplican para planes de contado ya que no manejan cuotas.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Visibilidad del Plan al Cliente -->
          <div class="mb-8">
            <h3 class="text-lg font-medium text-foreground mb-4 flex items-center">
              <i class="fas fa-eye text-primary mr-2"></i>
              Visibilidad del Plan al Cliente
            </h3>

            <div class="rounded-lg border border-border bg-muted/40 p-4">
              <div class="flex items-center justify-between mb-3">
                <div class="flex items-center">
                  <i class="text-lg mr-2"
                     [class.fas]="true"
                     [class.fa-eye]="plan.params?.client_visible !== false"
                     [class.text-primary]="plan.params?.client_visible !== false"
                     [class.fa-eye-slash]="plan.params?.client_visible === false"
                     [class.text-muted-foreground]="plan.params?.client_visible === false"></i>
                  <h4 class="text-md font-medium text-foreground">Plan {{ plan.params?.client_visible === false ? 'Oculto' : 'Visible' }} para Clientes</h4>
                </div>
                <div class="flex items-center">
                  <span class="kb-badge"
                        [ngClass]="plan.params?.client_visible !== false ? 'kb-badge-marca' : 'kb-badge-neutro'">
                    <i class="fas text-xs mr-1"
                       [class.fa-check-circle]="plan.params?.client_visible !== false"
                       [class.fa-ban]="plan.params?.client_visible === false"></i>
                    {{ plan.params?.client_visible === false ? 'Oculto' : 'Visible' }}
                  </span>
                </div>
              </div>

              <p class="text-sm text-muted-foreground mb-3">
                <span *ngIf="plan.params?.client_visible !== false; else planHidden">
                  Este plan está visible para los clientes en la aplicación móvil y web. Los clientes pueden ver y solicitar este plan.
                </span>
                <ng-template #planHidden>
                  Este plan está oculto para los clientes. Solo los administradores pueden verlo en la consola. Los clientes no podrán solicitar este plan.
                </ng-template>
              </p>

              <div class="flex items-start space-x-2 text-xs text-muted-foreground">
                <i class="fas fa-info-circle mt-0.5"></i>
                <div>
                  <p class="font-medium mb-1">Información:</p>
                  <p *ngIf="plan.params?.client_visible !== false">
                    <span class="text-primary">✓ Disponible para solicitudes</span> - Los clientes pueden ver este plan en sus opciones de financiamiento.
                  </p>
                  <p *ngIf="plan.params?.client_visible === false">
                    <span class="text-muted-foreground">⊘ No disponible para solicitudes</span> - Este plan solo es visible en la consola administrativa.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Resumen de Configuración -->
          <div class="mt-8 pt-6 border-t border-border">
            <h3 class="text-lg font-medium text-foreground mb-4 flex items-center">
              <i class="fas fa-cog text-primary mr-2"></i>
              Resumen de Configuración
            </h3>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div class="bg-muted/50 p-4 rounded-lg border border-border">
                <div class="flex items-center">
                  <i class="fas fa-file-contract text-primary mr-2"></i>
                  <div>
                    <p class="text-sm font-medium text-foreground">Documentación</p>
                    <p class="text-lg font-semibold text-foreground">
                      {{ (plan.params?.generate_pagares ? 1 : 0) + (plan.params?.generate_pagares_fisico ? 1 : 0) }}/2
                    </p>
                    <p class="text-xs text-foreground">Tipos configurados</p>
                  </div>
                </div>
              </div>

              <div class="kb-caja-exito p-4 rounded-lg border" *ngIf="isPlanCredit()">
                <div class="flex items-center">
                  <i class="fas fa-calendar-check kb-texto-exito mr-2"></i>
                  <div>
                    <p class="text-sm font-medium kb-texto-exito">Política de Fechas</p>
                    <p class="text-lg font-semibold kb-texto-exito">
                      {{ plan.params?.weekday ? 'Flexible' : 'Estricta' }}
                    </p>
                    <p class="text-xs kb-texto-exito">Manejo de feriados</p>
                  </div>
                </div>
              </div>

              <div class="kb-caja-alerta p-4 rounded-lg border">
                <div class="flex items-center">
                  <i class="fas fa-shield-alt kb-texto-alerta mr-2"></i>
                  <div>
                    <p class="text-sm font-medium kb-texto-alerta">Nivel de Respaldo</p>
                    <p class="text-lg font-semibold kb-texto-alerta">
                      {{ plan.params?.generate_pagares && plan.params?.generate_pagares_fisico ? 'Alto' :
                         (plan.params?.generate_pagares || plan.params?.generate_pagares_fisico) ? 'Medio' : 'Bajo' }}
                    </p>
                    <p class="text-xs kb-texto-alerta">Seguridad legal</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Acciones -->
          <div class="mt-6 pt-6 border-t border-border">
            <div class="flex items-center justify-between">
              <div class="flex space-x-3">
                <!--
                <button class="kb-btn kb-btn-outline">
                  <i class="fas fa-file-download mr-2"></i>
                  Descargar Configuración
                </button>
                <button class="kb-btn kb-btn-outline">
                  <i class="fas fa-copy mr-2"></i>
                  Copiar Configuración
                </button>
                -->
                <button class="kb-btn kb-btn-outline">
                  <i class="fas fa-history mr-2"></i>
                  Ver Historial
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ══ AYUDA DE LA DERECHA — APAGADA ══════════════════════════════════
           🔴 Ocupaba un CUARTO de la pantalla de forma permanente, siempre, con
           texto de ayuda fijo. El resultado medido: los datos del plan —que son
           el motivo de entrar acá— vivían en la mitad del ancho (6 de 12
           columnas) mientras la ayuda se llevaba 3.

           📍 Y no se pierde nada: este mismo texto YA existe una segunda vez
           dentro de cada sección, detrás del botón «Ayuda». Estaba escrito dos
           veces, y la copia de adentro estaba marcada `` —o sea, se
           escondía justo en las pantallas grandes, que es donde trabaja todo el
           mundo—. Se le sacó el ``: ahora ese botón funciona en todos
           los tamaños y muestra la ayuda al lado de lo que explica.

           Se apaga con *ngIf="false" y NO se borra: si el dueño del producto la
           quiere de vuelta, es sacar esta línea. -->
      <div *ngIf="false" class="xl:col-span-3">
        <div class="kb-card sticky top-8">
          <div class="p-4 border-b border-border bg-muted/40">
            <h3 class="text-sm font-semibold text-foreground uppercase tracking-wide flex items-center">
              <i class="fas fa-lightbulb kb-texto-alerta mr-2"></i>
              Ayuda Contextual
            </h3>
            <p class="text-xs text-muted-foreground mt-1">Información sobre la sección actual</p>
          </div>

          <div class="p-4">
            <!-- Ayuda para Resumen -->
            <div *ngIf="activeSection === 'resumen'" class="space-y-4">
              <div class="flex items-start">
                <i class="fas fa-info-circle text-primary mt-1 mr-3 flex-shrink-0"></i>
                <div class="flex-1">
                  <h4 class="kb-aviso-titulo mb-2">Vista de Resumen del Plan</h4>
                  <div class="text-sm space-y-2">
                    <p><strong>Propósito:</strong> Información consolidada de todas las características y configuraciones del plan.</p>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Información Incluida:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><strong>Datos Básicos:</strong> Nombre, código, tipo y estado del plan</li>
                        <li><strong>Configuración Financiera:</strong> Montos, cuotas y términos de crédito</li>
                        <li><strong>Productos:</strong> Identificadores y tipos de productos asociados</li>
                        <li><strong>Filtros:</strong> Etiquetas y restricciones de acceso</li>
                        <li><strong>Métricas:</strong> Estadísticas actuales de uso del plan</li>
                        <li><strong>Configuración Adicional:</strong> Pagarés y políticas especiales</li>
                      </ul>
                    </div>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Beneficios del Resumen:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><strong>Vista Completa:</strong> Toda la información en una sola pantalla</li>
                        <li><strong>Formato Minimalista:</strong> Datos organizados de manera clara y concisa</li>
                        <li><strong>Acceso Rápido:</strong> Información clave sin navegar entre secciones</li>
                      </ul>
                    </div>

                    <div class="mt-3 p-2 rounded bg-primary/10">
                      <p class="font-medium text-xs">📋 Tip:</p>
                      <p class="text-xs">Usa el resumen para obtener una visión general antes de editar secciones específicas</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ayuda para Etiquetas -->
            <div *ngIf="activeSection === 'etiquetas'" class="space-y-4">
              <div class="flex items-start">
                <i class="fas fa-info-circle text-primary mt-1 mr-3 flex-shrink-0"></i>
                <div class="flex-1">
                  <h4 class="kb-aviso-titulo mb-2">¿Cómo funcionan las Etiquetas?</h4>
                  <div class="text-sm space-y-2">
                    <p><strong>Propósito:</strong> Las etiquetas permiten segmentar qué clientes pueden acceder a este plan.</p>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Modos de Filtro:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><strong>Lista Blanca:</strong> Solo usuarios CON estas etiquetas pueden acceder</li>
                        <li><strong>Lista Negra:</strong> Solo usuarios SIN estas etiquetas pueden acceder</li>
                      </ul>
                    </div>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Ejemplos de Etiquetas:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><code class="bg-card px-1 rounded text-xs">EMPLEADO_PUBLICO</code> - Funcionarios del sector público</li>
                        <li><code class="bg-card px-1 rounded text-xs">CLIENTE_PREMIUM</code> - Clientes con historial crediticio excelente</li>
                        <li><code class="bg-card px-1 rounded text-xs">MOROSO</code> - Clientes con pagos en mora</li>
                      </ul>
                    </div>

                    <div class="mt-3 p-2 rounded bg-primary/10">
                      <p class="font-medium text-xs">💡 Tip:</p>
                      <p class="text-xs">Sin etiquetas = Todos los usuarios pueden acceder</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ayuda para Penalidades -->
            <div *ngIf="activeSection === 'penalidades'" class="space-y-4">
              <div class="flex items-start">
                <i class="fas fa-info-circle text-primary mt-1 mr-3 flex-shrink-0"></i>
                <div class="flex-1">
                  <h4 class="kb-aviso-titulo mb-2">¿Cómo funcionan las Penalidades?</h4>
                  <div class="text-sm space-y-3 text-foreground">
                    <p><strong>Propósito:</strong> Las penalidades (fees) son cargos adicionales que se aplican al plan de crédito.</p>

                    <div class="mt-3">
                      <p class="font-medium mb-2">Tipos de Listas:</p>
                      <ul class="list-disc list-inside space-y-2 ml-2 text-xs">
                        <li><strong>Lista Blanca:</strong> Solo estas penalidades específicas se pueden aplicar al plan</li>
                        <li><strong>Lista Negra:</strong> Estas penalidades NO se pueden aplicar al plan (están excluidas)</li>
                      </ul>
                    </div>

                    <div class="mt-3 p-3 rounded bg-primary/10 border border-border">
                      <p class="font-medium text-sm mb-2">🔍 Reglas de Aplicación:</p>
                      <div class="space-y-2 text-xs">
                        <div class="p-2 bg-card rounded border">
                          <p class="font-medium kb-texto-exito mb-1">✓ Penalidad ACTIVA en el producto:</p>
                          <p>Aplica a <strong>todos los planes</strong> automáticamente, excepto si se agrega a la <strong>Lista Negra</strong> del plan.</p>
                        </div>
                        <div class="p-2 bg-card rounded border">
                          <p class="font-medium kb-texto-alerta mb-1">⊗ Penalidad INACTIVA en el producto:</p>
                          <p>Solo aplica si se agrega explícitamente a la <strong>Lista Blanca</strong> del plan.</p>
                        </div>
                      </div>
                    </div>

                    <div class="mt-3 p-2 rounded bg-primary/10">
                      <p class="font-medium text-xs">💡 Tip:</p>
                      <p class="text-xs">Si un plan no tiene listas configuradas, se aplican todas las penalidades activas del sistema</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ayuda para Filtros -->
            <div *ngIf="activeSection === 'filtros'" class="space-y-4">
              <div class="flex items-start">
                <i class="fas fa-info-circle kb-texto-exito mt-1 mr-3 flex-shrink-0"></i>
                <div class="flex-1">
                  <h4 class="text-sm font-semibold mb-2 kb-texto-exito">¿Cómo funcionan los Filtros?</h4>
                  <div class="text-sm space-y-2 kb-texto-exito">
                    <p><strong>Propósito:</strong> Los filtros controlan qué usuarios y en qué tiendas está disponible este plan.</p>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Tipos de Filtros:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><strong>Persona:</strong> Filtra por tipo de cliente (Natural/Jurídica)</li>
                        <li><strong>Tiendas:</strong> Controla en qué puntos de venta está disponible</li>
                        <li><strong>Códigos Dinámicos:</strong> Filtros avanzados por etiquetas específicas</li>
                      </ul>
                    </div>

                    <div class="mt-3 p-2 rounded kb-caja-exito">
                      <p class="font-medium text-xs">💡 Tip:</p>
                      <p class="text-xs">Combina múltiples filtros para un control granular de elegibilidad</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ayuda para Productos -->
            <div *ngIf="activeSection === 'productos'" class="space-y-4">
              <div class="flex items-start">
                <i class="fas fa-info-circle text-primary mt-1 mr-3 flex-shrink-0"></i>
                <div class="flex-1">
                  <h4 class="kb-aviso-titulo mb-2">¿Cómo funcionan los Productos?</h4>
                  <div class="text-sm space-y-2">
                    <p><strong>Propósito:</strong> Los identificadores determinan a qué productos se aplica este plan.</p>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Tipos Disponibles:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><code class="bg-card px-1 rounded text-xs">CREDIT</code> - Productos de crédito básico</li>
                        <li><code class="bg-card px-1 rounded text-xs">RECHARGE</code> - Productos de recarga</li>
                        <li><code class="bg-card px-1 rounded text-xs">SEGUROS_MERCANTIL</code> - Seguros del Banco Mercantil</li>
                      </ul>
                    </div>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Funcionamiento:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><strong>Restricción:</strong> Solo se puede asignar UN identificador por plan</li>
                        <li><strong>Herencia:</strong> El plan hereda las características del producto</li>
                      </ul>
                    </div>

                    <div class="mt-3 p-2 rounded bg-primary/10">
                      <p class="font-medium text-xs">💡 Tip:</p>
                      <p class="text-xs">Solo se puede asignar UN identificador por plan</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ayuda para Datos Básicos -->
            <div *ngIf="activeSection === 'datos-basicos'" class="space-y-4">
              <div class="flex items-start">
                <i class="fas fa-info-circle kb-texto-alerta mt-1 mr-3 flex-shrink-0"></i>
                <div class="flex-1">
                  <h4 class="text-sm font-semibold mb-2 kb-texto-alerta">¿Qué son los Datos Básicos?</h4>
                  <div class="text-sm space-y-2 kb-texto-alerta">
                    <p><strong>Propósito:</strong> Define la identidad y configuración fundamental del plan.</p>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Campos Principales:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><strong>Nombre:</strong> Identificación amigable del plan (ej: "Plan Empleados 2024")</li>
                        <li><strong>Código:</strong> Identificador único inmutable (ej: "EMP_2024_V1")</li>
                        <li><strong>Descripción:</strong> Detalles del plan para clientes</li>
                      </ul>
                    </div>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Estados del Plan:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><span class="kb-texto-exito">●</span> <strong>Activo:</strong> Visible y disponible para clientes</li>
                        <li><span class="text-destructive">●</span> <strong>Inactivo:</strong> Oculto para clientes</li>
                      </ul>
                    </div>

                    <div class="mt-3 p-2 rounded kb-caja-alerta">
                      <p class="font-medium text-xs">⚠️ Importante:</p>
                      <p class="text-xs">El código NO se puede cambiar una vez creado</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ayuda para Datos Generales -->
            <div *ngIf="activeSection === 'datos-generales'" class="space-y-4">
              <div class="flex items-start">
                <i class="fas fa-info-circle text-destructive mt-1 mr-3 flex-shrink-0"></i>
                <div class="flex-1">
                  <h4 class="text-sm font-semibold mb-2 text-destructive">¿Cómo configurar los Datos Generales?</h4>
                  <div class="text-sm space-y-2 text-destructive">
                    <p><strong>Propósito:</strong> Configuración financiera y términos de crédito del plan.</p>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Pago Inicial:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><strong>Requiere inicial:</strong> Si el plan exige pago inicial</li>
                        <li><strong>Tipo de cálculo:</strong> Porcentaje o monto fijo (ej: 20% o $50)</li>
                        <li><strong>Recalcular cuotas:</strong> Si ajusta cuotas tras el inicial</li>
                      </ul>
                    </div>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Plazos y Cuotas:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><strong>Opciones de cuotas:</strong> Cantidad de cuotas disponibles (ej: 2, 3, 4 cuotas)</li>
                        <li><strong>Frecuencia:</strong> Periodicidad de pago (ej: Mensual, quincenal)</li>
                      </ul>
                    </div>

                    <div class="mt-3 p-2 bg-card rounded border">
                      <p class="font-medium text-xs mb-1">Ejemplo Plan Empleados:</p>
                      <ul class="text-xs space-y-1">
                        <li>• Inicial: 20% del monto</li>
                        <li>• Cuotas: 2, 3, 4 opciones</li>
                        <li>• Cupo: $500 - $2,000</li>
                      </ul>
                    </div>

                    <div class="mt-3 p-2 rounded bg-destructive/10">
                      <p class="font-medium text-xs">💡 Tip:</p>
                      <p class="text-xs">Define términos de crédito y límites según el perfil de usuario</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ayuda para Clientes -->
            <div *ngIf="activeSection === 'clientes'" class="space-y-4">
              <div class="flex items-start">
                <i class="fas fa-info-circle text-primary mt-1 mr-3 flex-shrink-0"></i>
                <div class="flex-1">
                  <h4 class="kb-aviso-titulo mb-2">¿Cómo interpretar los Clientes?</h4>
                  <div class="text-sm space-y-2">
                    <p><strong>Propósito:</strong> Usuarios que actualmente tienen créditos activos con este plan.</p>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Estados de Cliente:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><span class="kb-texto-exito">●</span> <strong>Al día:</strong> Pagos al corriente</li>
                        <li><span class="text-destructive">●</span> <strong>Atrasado:</strong> Pagos en mora</li>
                      </ul>
                    </div>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Información Mostrada:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><strong>Crédito activo:</strong> Monto actual del crédito</li>
                        <li><strong>Progreso:</strong> Cuotas pagadas vs total</li>
                        <li><strong>Fecha inicio:</strong> Cuándo se otorgó el crédito</li>
                      </ul>
                    </div>

                    <div class="mt-3 p-2 rounded bg-primary/10">
                      <p class="font-medium text-xs">📊 Análisis:</p>
                      <p class="text-xs">Evalúa el rendimiento y riesgo del plan</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ayuda para Historial -->
            <div *ngIf="activeSection === 'historial'" class="space-y-4">
              <div class="flex items-start">
                <i class="fas fa-info-circle text-muted-foreground mt-1 mr-3 flex-shrink-0"></i>
                <div class="flex-1">
                  <h4 class="kb-aviso-titulo mb-2">¿Para qué sirve el Historial?</h4>
                  <div class="text-sm space-y-2">
                    <p><strong>Propósito:</strong> Registro completo de cambios y modificaciones del plan.</p>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Tipos de Cambios:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><strong>Modificaciones:</strong> Cambios en configuración</li>
                        <li><strong>Versiones:</strong> Nuevas versiones del plan</li>
                        <li><strong>Estados:</strong> Activación/desactivación</li>
                      </ul>
                    </div>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Información de Auditoría:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><strong>Fecha y hora:</strong> Cuándo se realizó el cambio</li>
                        <li><strong>Usuario:</strong> Quién realizó la modificación</li>
                        <li><strong>Detalles:</strong> Qué campos se modificaron</li>
                      </ul>
                    </div>

                    <div class="mt-3 p-2 rounded bg-muted">
                      <p class="font-medium text-xs">🔍 Auditoría:</p>
                      <p class="text-xs">Esencial para cumplimiento y trazabilidad</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ayuda para Métricas -->
            <div *ngIf="activeSection === 'metricas'" class="space-y-4">
              <div class="flex items-start">
                <i class="fas fa-info-circle text-primary mt-1 mr-3 flex-shrink-0"></i>
                <div class="flex-1">
                  <h4 class="kb-aviso-titulo mb-2">¿Cómo interpretar las Métricas?</h4>
                  <div class="text-sm space-y-2">
                    <p><strong>Propósito:</strong> Indicadores de rendimiento y estadísticas del plan.</p>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Indicadores Clave:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><span class="kb-texto-exito">●</span> <strong>Tasa de aprobación:</strong> Porcentaje de solicitudes aprobadas</li>
                        <li><strong>Promedio por crédito:</strong> Monto promedio otorgado</li>
                        <li><strong>Ingresos del mes:</strong> Ingresos generados por el plan</li>
                      </ul>
                    </div>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Interpretación:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><span class="kb-texto-exito">●</span> <strong>Verde:</strong> Indicadores positivos</li>
                        <li><span class="text-destructive">●</span> <strong>Rojo:</strong> Requiere atención</li>
                        <li><strong>Tendencias:</strong> Observa cambios en el tiempo</li>
                      </ul>
                    </div>

                    <div class="mt-3 p-2 rounded bg-primary/10">
                      <p class="font-medium text-xs">📈 Optimización:</p>
                      <p class="text-xs">Usa estas métricas para mejorar el rendimiento del plan</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Ayuda para Otros -->
            <div *ngIf="activeSection === 'otros'" class="space-y-4">
              <div class="flex items-start">
                <i class="fas fa-info-circle kb-texto-alerta mt-1 mr-3 flex-shrink-0"></i>
                <div class="flex-1">
                  <h4 class="text-sm font-semibold mb-2 kb-texto-alerta">¿Qué configurar en Otros?</h4>
                  <div class="text-sm space-y-2 kb-texto-alerta">
                    <p><strong>Propósito:</strong> Configuración adicional de documentación legal y políticas de cobranza.</p>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Documentación Legal:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><strong>Pagaré Electrónico:</strong> Genera automáticamente documento digital</li>
                        <li><strong>Pagaré Físico:</strong> Requiere documento físico firmado</li>
                      </ul>
                    </div>

                    <div class="mt-3">
                      <p class="font-medium mb-1">Políticas de Cobranza:</p>
                      <ul class="list-disc list-inside space-y-1 ml-2 text-xs">
                        <li><strong>Permitir cuotas en feriados:</strong> Si las fechas de pago pueden caer en fines de semana o feriados</li>
                        <li><strong>Ajuste automático:</strong> Mueve fechas al siguiente día hábil si está desactivado</li>
                        <li><strong>Diferir cuotas en feriados:</strong> Mueve automáticamente las cuotas de fines de semana y feriados al siguiente día hábil</li>
                        <li><strong>Permitir en cualquier día:</strong> Las fechas pueden caer en cualquier día si está desactivado</li>
                      </ul>
                    </div>

                    <div class="mt-3 p-2 rounded kb-caja-alerta">
                      <p class="font-medium text-xs">⚖️ Legal:</p>
                      <p class="text-xs">Los pagarés son documentos legales que respaldan el crédito</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Mensaje por defecto cuando no hay sección activa -->
            <div *ngIf="!activeSection" class="text-center py-8">
              <i class="fas fa-compass text-muted-foreground text-3xl mb-3"></i>
              <p class="text-sm text-muted-foreground">Selecciona una sección para ver la ayuda contextual</p>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>

<!-- Plan Not Found -->
<div *ngIf="!planLoading && !plan" class="kb-page">
  <div class="kb-empty">
    <i class="fas fa-exclamation-triangle kb-empty-icono"></i>
    <p class="kb-empty-titulo">Plan no encontrado</p>
    <p class="kb-empty-texto">El plan solicitado no existe o no tienes permisos para verlo.</p>
    <button (click)="goBack()" class="kb-btn kb-btn-primary mt-4">
      <i class="fas fa-arrow-left mr-2"></i>
      Volver a Dashboard
    </button>
  </div>
</div>
